<template>
  <v-container class="grey lighten-5">

    <v-card v-if="isErrorParam" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">マイ機器情報にアクセスできません</span>
      </div>
      <p class="caption">
        マイ機器情報にアクセスできません。<br>
        <br>
        すでに削除されているマイ機器情報を開こうとしているか、他の事業所のマイ機器情報にアクセスしています。<br>
        もう一度マイ機器一覧からアクセスしてください。<br>
      </p>
      <v-btn icon :to="{ path: 'mymachinelist' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>マイ機器一覧に戻る
    </v-card>

    <div v-if="!isErrorParam" class="my-3" >
      <v-btn icon @click="$router.back()">
<!--
      <v-btn icon @click="back()">
-->
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="display-1 pl-3" id="title">マイ機器</span>
<!--
      <template v-if="this.$store.state.operatingCompany.AnalizeTypeGroup=='航空機'">
        <span class="display-1" id="title">{{AnalizeTypeCategory}} {{machineTypeText}}</span>
-->
      <template v-if="AnalizeTypeCategory=='航空機'">
        <span class="display-1 pl-2" id="title">装備品</span>
      </template>

      <span class="display-1" v-if="isCreate" id="title">情報登録</span>
      <span v-else-if="isDetailInput" class="display-1" id="title">情報更新</span>
      <span v-else class="display-1" id="title">情報参照</span>
      
      <v-row class="ml-5 mt-3" dense>
        <v-col cols=12 dense v-if="!isDetailInput">
          <v-tooltip bottom color="grey darken-2" activator="#sample_btn" v-if ="!isCreate" >
            <span>クリックすると、分析サンプルの採取登録画面へ遷移します</span>
          </v-tooltip>
          <v-btn v-if ="!isCreate"
            rounded
            color="amber"
            :to="{ path: 'sampling/', query: { id: this.machineid }}"
            class="mx-2 mb-2 caption"
            small
          >
            <v-icon class="mr-2" small>mdi-cup-water</v-icon>分析サンプルを登録
          </v-btn>

          <v-btn rounded color="amber"
            class="mx-2 mb-2 caption"
            small
            @click="showUpdateUsageTime()"
            >
            <v-icon class="mr-2" small>mdi-clock-outline </v-icon>使用時間を更新
          </v-btn>

          <template v-if="AnalizeTypeCategory == '航空機'">
            <v-btn rounded color="amber"
              class="mx-2 mb-2 caption"
              small
              @click="showUpdateOverhaul()"
              >
              <v-icon class="mr-2" small>mdi-wrench-clock </v-icon>オーバーホール歴を登録
            </v-btn>
          </template>

          <v-btn rounded color="amber"
            class="mx-2 mb-2 caption"
            small
            @click="showUpdateOilChange()"
            >
            <v-icon class="mr-2" small>mdi-oil </v-icon>オイル交換歴を登録
          </v-btn>

<!--
          <v-btn rounded color="amber"
            class="mx-2 mb-2 caption"
            small
            @click="showDetailInput()"
            >
            <v-icon class="mr-2" >mdi-application-edit-outline</v-icon>その他の登録情報を更新する
          </v-btn>
-->

         <v-tooltip bottom color="grey darken-2" activator="#qr_btn" v-if ="!isCreate" >
            <span>クリックすると、{{machineTypeText}}専用のQRコード確認画面へ遷移します</span>
          </v-tooltip>
          <v-btn v-if ="!isCreate"
            rounded
            color="amber"
            :to="{ path: 'mymachineqrcode/', query: { id: this.machineid,  name: this.Name, type: this.Type, machineid: this.CustomerMachineID, PurchasedDate: this.PurchasedDate}}"
            class="mx-2 mb-2 caption"
            small
          >
            <v-icon class="mr-2" small>mdi-qrcode</v-icon>マイ機器QRコードを確認
          </v-btn>

        <template v-if="isDeveloper">
          <v-tooltip bottom color="grey darken-2" activator="#copy_btn" v-if ="!isCreate" >
            <span>表示中の{{machineTypeText}}情報をコピーして新しい{{machineTypeText}}情報を登録します</span>
          </v-tooltip>
          <v-btn v-if ="!isCreate" rounded color="blue"
            class="mx-2 mb-2 caption"
            small
            @click="copyMachine()"
          >
            <v-icon class="mr-2" small>mdi-content-copy </v-icon>コピーして新規作成
          </v-btn>
        </template>
        </v-col>
        <v-col cols=12 dense v-if="!isCreate && isDetailInput">
          <v-btn rounded color="amber"
            class="mx-2 mb-2 caption"
            small
            @click="closeDetailInput()"
          >
            <v-icon class="mr-2" small>mdi-close</v-icon>更新をやめる
          </v-btn>

          <v-btn v-if ="!isCreate"
            rounded
            color="amber"
            class="mx-2 mb-2 caption"
            @click="openMachineLog(machineid)"
            small
          >
            <v-icon class="mr-2" small>mdi-clipboard-text-clock-outline</v-icon>履歴
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-card v-if="!isDetailInput" class="py-1">
      <v-card-text>
<!--
        <v-card class="py-1" v-if="AnalizeTypeCategory=='航空機'">
-->
        <v-card class="py-1" v-if="AnalizeTypeCategory=='航空機' && !mountedMachine">
          <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
            関連付けされている機体情報
          </v-card-title>
          <v-card-text class="mb-0 pb-0">
            この装備品は機体に関連づいていません。
          </v-card-text>
          <v-card-actions>
            <v-row dense>
              <v-col cols=12 dense>
                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showMountMachine()"
                  >
                  <v-icon class="mr-2" >mdi-airplane-plus </v-icon>機体に関連付ける
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>

        <v-card class="py-1" v-if="mountedMachine">
          <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
            関連付けされている機体情報
          </v-card-title>
          <v-card-text class="mb-0 pb-0">
              <v-row dense class="pt-2 pb-0 pl-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2 ">
                    項目名
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                    項目名（補足）
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                    設定内容
                  </div>
                </v-col>
              </v-row>

              <v-row dense class="pa-2 pt-0">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.Name}}
                    <template v-if="!mountedMachine.Name">-</template>
                  </div>
                </v-col>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.CustomerMachineID}}
                    <template v-if="!mountedMachine.CustomerMachineID">-</template>
                  </div>
                </v-col>
-->

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('搭載位置')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('搭載位置')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MountPosition}}
                    <template v-if="!MountPosition">-</template>
                  </div>
                </v-col>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.TotalOperatingTime}} {{mountedMachine.TotalOperatingTimeUnitText}}
                    <template v-if="!mountedMachine.TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.SinceOverhaulTime}} {{mountedMachine.SinceOverhaulTimeUnitText}}
                    <template v-if="!mountedMachine.SinceOverhaulTime">-</template>
                  </div>
                </v-col>
-->
              </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row dense>
              <v-col cols=12 dense>
                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showMountMachine()"
                  >
                  <v-icon class="mr-2" >mdi-airplane-plus </v-icon>関連付けを<div class="font-weight-bold"> 変更 </div>する
                </v-btn>
                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showUnMountMachine()"
                  >
                  <v-icon class="mr-2" >mdi-airplane-minus </v-icon>関連付けを<div class="font-weight-bold"> 解除 </div>する
                </v-btn>
                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showAircraft()"
                  >
                  <v-icon class="mr-2" >mdi-airplane-minus </v-icon>機体情報を見る
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>

        <v-card outlined class="py-1 mt-3">
          <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
            {{machineTypeText}}情報
          </v-card-title>
          <v-card-text>
              <v-row dense class="pt-2 pb-0 pl-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2 ">
                    項目名
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                    項目名（補足）
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey white--text font-weight-bold pl-2">
                    設定内容
                  </div>
                </v-col>
              </v-row>

              <v-row dense class="pa-2 pt-0">
                <template v-if="AnalizeTypeCategory == '一般'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{Name}}
                      <template v-if="!Name">-</template>
                    </div>
                  </v-col>
                </template>

                <template v-else-if="AnalizeTypeCategory == '航空機' && !mountedMachine">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{Name}}
                      <template v-if="!Name">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{CustomerMachineID}}
                    <template v-if="!CustomerMachineID">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機械名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機械名')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{Equipment}}
                    <template v-if="!Equipment">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '一般'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('顧客名')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('顧客名')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{CustomerName}}
                      <template v-if="!CustomerName">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MakerText}}
                    <template v-if="!MakerText">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{ModelNumber}}
                    <template v-if="!ModelNumber">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{PurchasedDate}}
                    <template v-if="!PurchasedDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{TotalOperatingTime}} {{TotalOperatingTimeUnitText}}
                    <template v-if="!TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '航空機'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0" >
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理日')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理日')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{OverhaulDate}}
                      <template v-if="!OverhaulDate">-</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{SinceOverhaulTime}} {{SinceOverhaulTimeUnitText}}
                      <template v-if="!SinceOverhaulTime">-</template>
                    </div>
                  </v-col>
                </template>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MachineMemo}}
                    <template v-if="!MachineMemo">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('システム油量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('システム油量')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SystemOil}} {{SystemOilUnitText}}
                    <template v-if="!SystemOil">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('前回分析依頼日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('前回分析依頼日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{LatestOrderAt}}
                    <template v-if="!LatestOrderAt">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('前回分析依頼番号')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('前回分析依頼番号')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{LatestOrderNumber}}
                    <template v-if="!LatestOrderNumber">-</template>
                  </div>
                </v-col>
              </v-row>


              <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilTypeCategoryText}}／{{OilTypeText}} {{OilPropertyText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilmakerText}}／{{OilModelNumber}} {{OilGradeText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChangeDate}}
                    <template v-if="!OilChangeDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChange}} {{OilChangeUnitText}}
                    <template v-if="!OilChange">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilUsageTime}} {{OilUsageTimeUnitText}}
                    <template v-if="!OilUsageTime">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '航空機'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      <template v-if="UseFilter == undefined">使用していない</template>
                      <template v-else-if="!UseFilter">使用していない</template>
                      <template v-else-if="UseFilter">使用している</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用時間')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用時間')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{FilterUsageTime}} {{FilterUsageTimeUnitText}}
                      <template v-if="!FilterUsageTime">-</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{SamplingPlaceMessage}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{SamplingPlace}}
                      <template v-if="!SamplingPlace">-</template>
                    </div>
                  </v-col>
                </template>

              </v-row>

              <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析方法')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析方法')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeTypeGroup}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析区分')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析区分')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeTypeName}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeSetName}}
                    <template v-if="!AnalizeSetName">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('個別分析項目')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('個別分析項目')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pt-0">
                  <template v-for="(item, index) in analizeItemNames">
                    <v-chip small color="green" class="white--text ml-2 mb-1" :key="index"> {{item}}</v-chip>
                  </template>
                </v-col>

<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{AnalizePurposeLabel}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析目的')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pt-0">
                  {{AnalizePurpose}}
                  <template v-if="!AnalizePurpose">-</template>
                </v-col>
-->
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('フィルター返却')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('フィルター返却')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{getFilterText(Filter)}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル返却')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル返却')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{getSurplusText(Surplus)}}
                  </div>
                </v-col>

              </v-row>
          </v-card-text>

          <v-card-actions>
            <v-row dense>
              <v-col cols=12>
                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showUpdateUsageTime()"
                  >
                  <v-icon class="mr-2" small>mdi-clock-outline </v-icon>使用時間を更新
                </v-btn>

                <template v-if="AnalizeTypeCategory == '航空機'">
                  <v-btn rounded color="amber"
                    class="mx-2 mb-2 caption"
                    small
                    @click="showUpdateOverhaul()"
                    >
                    <v-icon class="mr-2" small>mdi-wrench-clock </v-icon>オーバーホール歴を登録
                  </v-btn>
                </template>

                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showUpdateOilChange()"
                  >
                  <v-icon class="mr-2" small>mdi-oil </v-icon>オイル交換歴を登録
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn rounded color="amber"
                  class="mx-2 mb-2 caption"
                  small
                  @click="showDetailInput()"
                  >
                  <v-icon class="mr-2" small>mdi-application-edit-outline</v-icon>その他の登録情報を更新
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>

  <v-form v-if="!isErrorParam && isDetailInput" ref="mymachine_form">
  <v-stepper
    v-model="e6"
    vertical
    editable
  >
    <v-stepper-step :complete="e6 > 1" step="1" @click="changeStepper(1)" editable color="teal darken-1">
      {{machineTypeText}}情報
    </v-stepper-step>
    <v-stepper-content step="1" class="mt-0 pt-0">
      <v-card class="py-2 mt-0 pt-0">
          <v-row dense>
            <v-col cols="12">
              <v-btn
                small
                text
                @click="showDescription1 = !showDescription1"
                class="mt-0 pt-0 mb-2 ml-0 pl-0"
              >
                <v-icon color="primary" class="mr-1">{{ showDescription1 ? 'mdi-chat-question-outline' : 'mdi-chat-question' }}</v-icon>{{machineTypeText}}情報の登録について
              </v-btn>
              <v-expand-transition>
              <v-card flat outlined class="pa-2 mb-6" v-show="showDescription1">
<!--
                <v-card-title class="caption pa-0">
                  <v-icon class="mr-1" color="primary">mdi-information-outline</v-icon>
                  <span class="primary--text">{{machineTypeText}}情報の登録について</span>
                </v-card-title>
-->
                <v-card-text class="caption">
                  分析・診断サービスの対象となるオイルを使用している機器（エンジン、ギア、変速機など）の情報を登録してください。<br>
                  <br>
                  <v-icon class="mr-1" color="grey darken-4">mdi-certificate-outline</v-icon>がついている項目は報告書に記載される項目です。<br>
                  報告書への記載をご希望の場合は入力をお願いします。
                </v-card-text>
              </v-card>
              </v-expand-transition>
            </v-col>
          </v-row>

          <template v-if="AnalizeTypeCategory == '航空機' && mountedMachine">
            <v-row >
              <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="mountedMachine.Name"
                      :label="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']"
                      readonly
                      :messages="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
<!--
                  <span class="wrap-text">{{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'description']}}</span>
-->
                  <span class="wrap-text">{{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']}}（{{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}）の変更は関連づいている機体情報を変更して下さい。</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              </v-col>

              <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="MountPosition"
                      :label="getItemName('搭載位置')[AnalizeTypeCategory+'label']"
                      counter=2
                      @input="$v.MountPosition.$touch()"
                      :error-messages="MountPositionErrors"
                      :messages="getItemName('搭載位置')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('搭載位置')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('搭載位置')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              </v-col>
            </v-row>
          </template>

          <template v-if="AnalizeTypeCategory == '航空機' && !mountedMachine">
            <v-row >
              <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="Name"
                      :label="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']"
                      :counter="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'counter']"
                      @input="$v.Name.$touch()"
                      :error-messages="NameErrors"
                      :messages="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('マイ機器名_機体')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              </v-col>

            </v-row>
          </template>



          <v-row dense>
            <template v-if="AnalizeTypeCategory == '一般'">
<!--
            <template v-if="!mountedMachine">
-->
              <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="Name"
                      :label="getItemName('マイ機器名')[AnalizeTypeCategory+'label']"
                      :counter="getItemName('マイ機器名')[AnalizeTypeCategory+'counter']"
                      @input="$v.Name.$touch()"
                      :error-messages="NameErrors"
                      :messages="getItemName('マイ機器名')[AnalizeTypeCategory+'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('マイ機器名')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('マイ機器名')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>
              </v-col>
            </template>

            <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="CustomerMachineID"
                    :label="getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'counter']"
                    @input="$v.CustomerMachineID.$touch()"
                    :error-messages="CustomerMachineIDErrors"
                    :messages="getItemName('マイ機器ＩＤ')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <template v-if="AnalizeTypeCategory == '航空機'">
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>
              </template>
            </v-col>

            <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="Equipment"
                    :label="getItemName('機械名')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('機械名')[AnalizeTypeCategory+'counter']"
                    @input="$v.Equipment.$touch()"
                    :error-messages="EquipmentErrors"
                    :messages="getItemName('機械名')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('機械名')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('機械名')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>

            <template v-if="AnalizeTypeCategory == '一般'">
              <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="CustomerName"
                      :label="getItemName('顧客名')[AnalizeTypeCategory+'label']"
                      :counter="getItemName('顧客名')[AnalizeTypeCategory+'counter']"
                      @input="$v.CustomerName.$touch()"
                      :error-messages="CustomerNameErrors"
                      :messages="getItemName('顧客名')[AnalizeTypeCategory + 'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('顧客名')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('顧客名')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
            </template>
          </v-row>
<!--
          <template v-if="isCreateMounted">
            <v-row dense>
              <v-col cols="12" dense>
                <div class="ma-0 pt-2 body-2" v-if="mountedMachine">
                  <v-icon class="mr-1" color="primary">mdi-information</v-icon>
                  {{mountedMachine.CustomerMachineID}} の装備品として登録します。搭載位置を入力してください
                </div>
              </v-col>
              <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
                <v-text-field
                  v-model="MountPosition"
                  :label="getItemName('搭載位置')[AnalizeTypeCategory+'label']"
                  counter=10
                  @input="$v.MountPosition.$touch()"
                  :error-messages="MountPositionErrors"
                  :messages="getItemName('搭載位置')[AnalizeTypeCategory + 'message']"
                >
                  <template v-slot:prepend-inner v-if="getItemName('搭載位置')[AnalizeTypeCategory+'証明書']">
                    <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
            </v-row>
          </template>
-->

          <v-row dense>
            <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
              <v-text-field
                v-model="MakerID"
                :label="getItemName('製造メーカー名')[AnalizeTypeCategory+'label']"
                :counter="getItemName('製造メーカー名')[AnalizeTypeCategory+'counter']"
                @change="changeMaker"
                @input="$v.MakerID.$touch()"
                :error-messages="MakerIDErrors"
                :messages="getItemName('製造メーカー名')[AnalizeTypeCategory + 'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('製造メーカー名')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>

            <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="ModelNumber"
                    :label="getItemName('型式')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('型式')[AnalizeTypeCategory+'counter']"
                    @input="$v.ModelNumber.$touch()"
                    :error-messages="ModelNumberErrors"
                    :messages="getItemName('型式')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('型式')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('型式')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>


<!-- 2.4不対応
            <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
              <v-select
                v-model="MachineCategory"
                :label="getItemName('機械の種類')[AnalizeTypeCategory+'label']"
                dense
                class="mb-3"
                :items="machineCategoryList"
                item-value="Value"
                item-text="Text"
                @change="changeMachineCategory()"
                :messages="getItemName('機械の種類')[AnalizeTypeCategory + 'message']"
               >
                <template v-slot:prepend-inner v-if="getItemName('機械の種類')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-select>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>

            <v-col cols="10" xl="5" lg="5" md='5' sm='10' xs="10" dense>
              <v-select
                v-model="MachineType"
                :label="getItemName('機械の詳細')[AnalizeTypeCategory+'label']"
                dense
                class="mb-3"
                :items="machineTypeList"
                item-value="Value"
                item-text="Text"
                :messages="getItemName('機械の詳細')[AnalizeTypeCategory + 'message']"
               >
                <template v-slot:prepend-inner v-if="getItemName('機械の詳細')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
               </v-select>

              <v-text-field
                v-if="MachineType=='99999999'"
                v-model="MachineTypeText"
                :label="getItemName('機械の詳細（その他）')[AnalizeTypeCategory+'label']"
                dense
                class="mb-3"
                counter=30
                :messages="getItemName('機械の詳細（その他）')[AnalizeTypeCategory + 'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('機械の詳細（その他）')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
-->
          </v-row>
          <v-row dense>
            <v-col cols="12" xl="2" lg="2" md='3' sm='3' xs="12" dense>
              <v-menu
                v-model="purchasedDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="PurchasedDate"
                    :label="getItemName('機器導入日')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @input="$v.PurchasedDate.$touch()"
                    :error-messages="PurchasedDateErrors"
                    :messages="getItemName('機器導入日')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('機器導入日')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="PurchasedDate"
                  @input="purchasedDatePicker = false"
                  locale="ja"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="7" xl="2" lg="2" md='3' sm='3' xs="7" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="TotalOperatingTime"
                    :label="getItemName('累計使用時間／距離')[AnalizeTypeCategory+'label']"
                    @input="$v.TotalOperatingTime.$touch()"
                    :error-messages="TotalOperatingTimeErrors"
                    :messages="getItemName('累計使用時間／距離')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('累計使用時間／距離')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('累計使用時間／距離')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

            <template v-if="AnalizeTypeCategory == '一般'">
              <v-col cols="5" xl="1" lg="2" md='2' sm='2' xs="5" dense>
                <v-select
                  v-model="TotalOperatingTimeUnit"
                  label="単位"
                  :items="useUnits"
                  item-value="Value"
                  item-text="Text"
                  clearable
                  @change="changeTotalOperatingTimeUnit()"
                ></v-select>
              </v-col>
              <v-col cols="1" xl="1" lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
            </template>
          </v-row>

          <v-row dense v-if="AnalizeTypeCategory == '航空機'">

            <v-col cols="12" xl="2" lg="2" md='3' sm='12' xs="3" dense>
              <v-menu
                v-model="overhaulDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="OverhaulDate"
                    :label="getItemName('修理日')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @input="$v.OverhaulDate.$touch()"
                    :error-messages="OverhaulDateErrors"
                    :messages="getItemName('修理日')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('修理日')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="OverhaulDate"
                  @input="overhaulDatePicker = false"
                  locale="ja"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="7" xl="2" lg="2" md='3' sm='6' xs="7" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="SinceOverhaulTime"
                    :label="getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']"
                    @input="$v.SinceOverhaulTime.$touch()"
                    :error-messages="SinceOverhaulTimeErrors"
                    :messages="getItemName('修理後使用時間／距離')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
<!--
            <v-col cols="3" xl="1" lg="1" md='2' sm='2' xs="2" dense>
              <v-select
                v-model="SinceOverhaulTimeUnit"
                label="単位"
                dense
                :items="useUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeSinceOverhaulTimeUnit()"
              ></v-select>
            </v-col>
-->

          </v-row>
          <v-row dense>

            <v-col cols="7" xl="1" lg="2" md='3' sm='3' xs="7" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="SystemOil"
                    :label="getItemName('システム油量')[AnalizeTypeCategory+'label']"
                    @input="$v.SystemOil.$touch()"
                    :error-messages="SystemOilErrors"
                    :messages="getItemName('システム油量')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('システム油量')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('システム油量')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="5" xl="1" lg="1" md='2' sm='2' xs="5" dense>
              <v-select
                v-model="SystemOilUnit"
                label="単位"
                :items="liquidUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeSystemOilUnit()"
              ></v-select>
            </v-col>
          </v-row>

<!--
          <v-row dense>          
            <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="OperatingTime"
                    label="前回分析依頼からの使用時間／距離"
                    dense
                    @input="$v.OperatingTime.$touch()"
                    :error-messages="OperatingTimeErrors"
                  ></v-text-field>
                </template>
                <span>前回分析依頼からの機器の使用量を時間または距離で入力してください。</span>
              </v-tooltip>
            </v-col>
            <v-col cols="4" xl="1" lg="2" md='2' sm='4' xs="4" dense>
              <v-select v-model="OperatingTimeUnit" label="単位" dense :items="useUnits" item-value="Value" item-text="Text"
                clearable
                @change="changeOperatingTimeUnit()"
               ></v-select>
            </v-col>
            <v-col cols="1" xl="1" lg="1" md='1' sm='2' xs="2" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" rounded color="amber" data-putMachine class="ma-2" @click="calcOperatingTime" x-small>計 算</v-btn>
                </template>
                <span>前回分析時の累計使用量から自動計算します</span>
              </v-tooltip>
            </v-col>
            <v-col cols="5" md="3" class="align-end" dense> 
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
              <v-text-field
                v-model="LatestOperatingTime"
                label="前回分析時の累計時間／距離"
                @input="$v.LatestOperatingTime.$touch()"
                :error-messages="LatestOperatingTimeErrors"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="4" xl="1" lg="2" md='2' sm='4' xs="4" dense>
              <v-select v-model="LatestOperatingTimeUnit" label="単位" dense :items="useUnits" item-value="Value" item-text="Text"
                clearable
                @change="changeLatestOperatingTimeUnit()"
               ></v-select>

            </v-col>
            <v-col cols="1" xl="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>

          </v-row>
-->

          <v-row >
            <v-col cols="6" xl="2" lg="2" md='3' sm='3' xs="6" dense>
              <v-menu
                v-model="latestOrderAtPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="LatestOrderAt"
                    :label="getItemName('前回分析依頼日')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @input="$v.LatestOrderAt.$touch()"
                    :error-messages="LatestOrderAtErrors"
                    :messages="getItemName('前回分析依頼日')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('前回分析依頼日')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="LatestOrderAt"
                  @input="latestOrderAtPicker = false"
                  locale="ja"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" xl="2" lg="2" md='3' sm='3' xs="6" dense>

              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="LatestOrderNumber"
                    :label="getItemName('前回分析依頼番号')[AnalizeTypeCategory+'label']"
                    v-on="on"
                    :counter="getItemName('前回分析依頼番号')[AnalizeTypeCategory+'counter']"
                    @input="$v.LatestOrderNumber.$touch()"
                    :error-messages="LatestOrderNumberErrors"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('前回分析依頼番号')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('前回分析依頼番号')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="12" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-textarea
                    v-model="MachineMemo"
                    :label="getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']"
                    v-on="on"
                    filled
                    counter=256
                    dense
                    class="mb-3"
                    @input="$v.MachineMemo.$touch()"
                    :error-messages="MachineMemoErrors"
                    :messages="getItemName('マイ機器メモ')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('マイ機器メモ')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-textarea>
                </template>
                <span class="wrap-text">{{getItemName('マイ機器メモ')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

          </v-row>
          <v-btn color="primary" @click="changeStepper(2)" outlined>次へ</v-btn>

          <v-overlay absolute :value="overlayStepper1" opacity="0.8" color="white">
            <v-progress-circular indeterminate size="64" color="amber"></v-progress-circular>
          </v-overlay>

      </v-card>
    </v-stepper-content>

    <v-stepper-step :complete="e6 > 2" step="2" @click="changeStepper(2)" color="teal darken-1">
      使用オイル情報
    </v-stepper-step>
    <v-stepper-content step="2" class="mt-0 pt-0">
      <v-card class="py-2 mt-0 pt-0">
          <v-row dense>
            <v-col cols="12">
              <v-btn
                text
                small
                @click="showDescription2 = !showDescription2"
                class="mt-0 pt-0 mb-2"
              >
                <v-icon color="primary" class="mr-1">{{ showDescription2 ? 'mdi-chat-question-outline' : 'mdi-chat-question' }}</v-icon>使用オイル情報について
              </v-btn>
              <v-expand-transition>
              <v-card flat outlined class="pa-2 mb-6" v-show="showDescription2">
<!--
                <v-card-title class="pa-0 caption">
                  <v-icon class="mr-1" color="primary">mdi-information-outline</v-icon>
                  <span class="primary--text">使用オイル情報の登録について</span>
                </v-card-title>
-->
                <v-card-text class="caption">
                  この機器で使用しているオイルの情報を入力してください。<br>
                  オイル交換などで使用オイルが変わった場合は、都度更新しておくと次回分析依頼時に自動設定されますので便利です。<br>
                  <br>
                  <v-icon class="mr-1" color="grey darken-4">mdi-certificate-outline</v-icon>がついている項目は報告書に記載される項目です。<br>
                  報告書への記載をご希望の場合は入力をお願いします。
                </v-card-text>
              </v-card>
              </v-expand-transition>
            </v-col>
          </v-row>


        <!--
          <v-row dense v-if ="isCreate">
            <v-col cols="12"  lg="12" md='12' sm='12' xs="12">
              <v-card flat outlined class="pa-3">
                <div class="subtitle-2 mb-2">
                  <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
                  <span class="primary--text">使用オイル情報の登録について</span>
                </div>
                <p class="caption">
                  この機器で使用しているオイルの情報を入力してください。<br>
                  オイル交換などで使用オイルが変わった場合は、都度更新しておくと次回分析依頼時に自動設定されますので便利です。
                </p>
              </v-card>
            </v-col>
          </v-row>
-->
          <v-row dense class="py-2">
            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
                  <v-select
                    v-model="OilTypeCategory"
                    :label="getItemName('オイルの種類')[AnalizeTypeCategory+'label']"
                    :items="oilTypeCategoryList"
                    item-value="Value"
                    item-text="Text"
                    @input="$v.OilTypeCategory.$touch()"
                    @blur="$v.OilTypeCategory.$touch()"
                    :error-messages="OilTypeCategoryErrors"
                    @change="changeOilTypeCategory()"
                    :messages="getItemName('オイルの種類')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイルの種類')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-select>
                  
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-select
                    v-on="on"
                    v-model="OilType"
                    :label="getItemName('オイルの詳細')[AnalizeTypeCategory+'label']"
                    :items="OilTypeList"
                    item-value="Value"
                    item-text="Text"
                    @input="$v.OilType.$touch()"
                    @blur="$v.OilType.$touch()"
                    :error-messages="OilTypeErrors"
                    @change="changeOilType()"
                    :messages="getItemName('オイルの詳細')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイルの詳細')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-select>
                </template>
                <span class="wrap-text">{{getItemName('オイルの詳細')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

            <template v-if="isOtherOilType(OilType)">
              <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense >
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="OilTypeText"
                    :label="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'counter']"
                    @input="$v.OilTypeText.$touch()"
                    @blur="$v.OilTypeText.$touch()"
                    :error-messages="OilTypeTextErrors"
                    :messages="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('オイルの詳細（その他）')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
              </v-col>
            </template>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <template v-if="hasOilProperties">
              <v-col cols="10" xl="2" lg="3" md='3' sm='10' xs="10" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-select
                      v-on="on"
                      v-model="OilProperty"
                      :label="getItemName('オイルの性質')[AnalizeTypeCategory+'label']"
                      :items="OilPropertyList"
                      item-value="Value"
                      item-text="Text"
                      @input="$v.OilProperty.$touch()"
                      @blur="$v.OilProperty.$touch()"
                      :error-messages="OilPropertyErrors"
                      @change="changeOilProperty()"
                      :messages="getItemName('オイルの性質')[AnalizeTypeCategory + 'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('オイルの性質')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-select>
                  </template>
                  <span class="wrap-text">{{getItemName('オイルの性質')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
                <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>
              </v-col>
            </template>
          </v-row>

          <v-row dense>
            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
              <v-text-field
                v-model="OilmakerID"
                :label="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'label']"
                counter=20
                @input="$v.OilmakerID.$touch()"
                @blur="$v.OilmakerID.$touch()"
                :error-messages="OilmakerIDErrors"
                :messages="getItemName('使用オイルメーカー')[AnalizeTypeCategory + 'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="2" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>

            <v-col cols="10" xl="3" lg="3" md='3' sm='10' xs="10" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="OilModelNumber"
                    :label="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'label']"
                    :counter="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'counter']"
                    @input="$v.OilModelNumber.$touch()"
                    @blur="$v.OilModelNumber.$touch()"
                    :error-messages="OilModelNumberErrors"
                    :messages="getItemName('使用オイル銘柄')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('使用オイル銘柄')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
<!-- 2.4不対応
            <v-col cols="10" xl="2" lg="3" md='3' sm='10' xs="10" dense>
              <v-select
                v-model="OilGrade"
                :label="getItemName('使用オイルグレード')[AnalizeTypeCategory+'label']"
                :items="oilGradeList"
                item-value="Value"
                item-text="Text"
                dense
                :messages="getItemName('使用オイルグレード')[AnalizeTypeCategory + 'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('使用オイルグレード')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-select>

            </v-col>
            <v-col cols="2" lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
-->

            <v-col cols="12" class="px-md-6 pa-2">
              <v-card v-if="getNoticeType==1" flat outlined class="pa-5">
                <div class="mb-2">
                  <v-icon class="mr-1" color="red">mdi-information</v-icon>
                  <span class="red--text">このオイルの分析・診断サービスのご利用は、事前にジャパン・アナリストにご相談ください。</span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span>お取り扱いに注意が必要なオイルのため、分析・診断サービスのお申込みの前にジャパン・アナリストに注意事項などを確認してください。<br></span>
                  <span>オイルの成分、性質によっては分析・診断サービスをご利用頂けない場合ごございます。ご了承ください。<br></span>
                  <br>
                  <span>オイルに含まれる危険物の情報などを記入してください</span>
                  <v-chip class="ma-2" color="red" text-color="white" x-small dense>必須</v-chip>
                </div>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-textarea
                      v-on="on"
                      v-model="HazardousMaterialsDetail"
                      :label="getItemName('危険物の内容')[AnalizeTypeCategory+'label']"
                      filled
                      @input="$v.HazardousMaterialsDetail.$touch()"
                      @blur="$v.HazardousMaterialsDetail.$touch()"
                      :error-messages="HazardousMaterialsDetailErrors"
                      :messages="getItemName('危険物の内容')[AnalizeTypeCategory + 'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('危険物の内容')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-textarea>
                  </template>
                  <span class="wrap-text">{{getItemName('危険物の内容')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-card>

              <v-card v-if="getNoticeType==2" flat outlined class="pa-5">
                <div class="mb-2">
                  <v-icon class="mr-1" color="red">mdi-information</v-icon>
                  <span class="red--text">このオイルは分析・診断サービスをご利用いただけません。</span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span>お取り扱いに注意が必要なオイルのため、分析・診断サービスの利用は個別にご相談頂いております。<br></span>
                  <span>お手数おかけ致しますが、ジャパン・アナリストまでご連絡ください。<br></span>
                  <br>
                </div>
              </v-card>

              <v-card v-if="getNoticeType==4" flat outlined class="pa-5">
                <div class="mb-2">
                  <v-icon class="mr-1" color="red">mdi-information</v-icon>
                  <span class="red--text">このオイルの分析・診断サービスのご利用は、ジャパン・アナリストにご相談ください。</span>
                </div>
                <div class="subtitle-2 mb-2">
                  <span>このオイルの分析は個別にご相談を承ります。<br></span>
                  <span>お手数おかけ致しますが、ジャパン・アナリストまでご連絡ください。<br></span>
                  <br>
                </div>
              </v-card>

            </v-col>

<!--
            <v-col cols="4" md="3" dense>
              <v-radio-group v-model="isHazardousMaterials">
                <template v-slot:label>
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">使用オイルに危険物が</div>
                    </template>
                    <span>オイルに危険物の有無を選択してください。</span>
                  </v-tooltip>
                </template>
                <v-radio value="1">
                  <template v-slot:label>
                    <div> <strong class="red--text">あります</strong></div>
                  </template>
                </v-radio>
                <v-radio value="0">
                  <template v-slot:label>
                    <div> <strong class="black--text">ありません</strong></div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="12" v-if="isHazardousMaterials==1">
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-textarea
                    v-on="on"
                    v-model="HazardousMaterialsDetail"
                    label="使用オイルの危険物の内容を入力してください"
                    dense
                    filled
                    @input="$v.HazardousMaterialsDetail.$touch()"
                    @blur="$v.HazardousMaterialsDetail.$touch()"
                    :error-messages="HazardousMaterialsDetailErrors"
                  ></v-textarea>
                </template>
                <span>オイルに含まれる危険物情報をできるだけ詳細に入力してください。</span>
              </v-tooltip>
            </v-col>
-->
          </v-row>



          <v-row dense class="mt-4">
            <v-col cols="12" xl="2" lg="2" md='3' sm='3' xs="12" dense>
              <v-menu
                v-model="oilChangeDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-on="on"
                    v-model="OilChangeDate"
                    :label="getItemName('オイル交換日')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    clearable
                    :messages="getItemName('オイル交換日')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイル交換日')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="OilChangeDate"
                  @input="oilChangeDatePicker = false"
                  locale="ja"
                >
                  <span class="px-2 grey darken-2 white--text caption wrap-text">{{getItemName('オイル交換日')[AnalizeTypeCategory+'description']}}</span>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="7" xl="2" lg="2" md='3' sm='3' xs="7" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="OilChange"
                    :label="getItemName('オイル交換量')[AnalizeTypeCategory+'label']"
                    @input="$v.OilChange.$touch()"
                    :error-messages="OilChangeErrors"
                    :messages="getItemName('オイル交換量')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイル交換量')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('オイル交換量')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="5" xl="1" lg="2" md='2' sm='2' xs="5" dense>
              <v-select
                v-model="OilChangeUnit"
                label="単位"
                :items="liquidUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeOilChangeUnit()"
              ></v-select>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="7" xl="2" lg="2" md='3' sm='3' xs="7" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="OilUsageTime"
                    :label="getItemName('オイル使用時間')[AnalizeTypeCategory+'label']"
                    @input="$v.OilUsageTime.$touch()"
                    :error-messages="OilUsageTimeErrors"
                    :messages="getItemName('オイル使用時間')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイル使用時間')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('オイル使用時間')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

            <template v-if="AnalizeTypeCategory == '一般'">
              <v-col cols="5" xl="2" lg="2" md='2' sm='2' xs="5" dense>
                <v-select
                  v-model="OilUsageTimeUnit"
                  label="単位"
                  :items="useUnits"
                  item-value="Value"
                  item-text="Text"
                  clearable
                  @change="changeOilUsageTimeUnit()"
                ></v-select>
              </v-col>
              <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
            </template>
          </v-row>

          <template v-if="AnalizeTypeCategory=='航空機'">

            <v-row class="mt-4">
              <v-col cols=12 dense>
                <v-checkbox
                  v-model="UseFilter"
                  label="オイルフィルター情報を報告書に印字する"
                  class="caption my-0 py-0"
                  dense
                  messages="※ 航空機フィルタ試験をご依頼の際は必須情報です。"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row class="ml-6" v-if="UseFilter">
              <v-col cols="4" xl="2" lg="2" md='3' sm='3' xs="3" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="FilterUsageTime"
                      class="mt-0 pt-0 mb-6"
                      :label="getItemName('フィルター使用時間')[AnalizeTypeCategory+'label']"
                      @input="$v.FilterUsageTime.$touch()"
                      :error-messages="FilterUsageTimeErrors"
                      :messages="getItemName('フィルター使用時間')[AnalizeTypeCategory + 'message']"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('フィルター使用時間')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('フィルター使用時間')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
<!--
              <v-col cols="4" xl="1" lg="1" md='2' sm='3' xs="2" dense>
                <v-select
                  v-model="FilterUsageTimeUnit"
                  label="単位"
                  dense
                  :items="useUnits"
                  item-value="Value"
                  item-text="Text"
                  clearable
                  @change="changeFilterUsageTimeUnit()"
                ></v-select>
              </v-col>
              <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
              </v-col>
              <v-col cols="5" md="3" class="align-end" dense> 
              </v-col>
-->
            </v-row>
          </template>

          <v-btn color="primary" @click="changeStepper(3)" outlined>次へ</v-btn>
      </v-card>
    </v-stepper-content>

    <v-stepper-step :complete="e6 > 3" step="3" @click="changeStepper(3)" color="teal darken-1">
      オイル分析・診断依頼内容（標準）
    </v-stepper-step>
    <v-stepper-content step="3" class="mt-0 pt-0">
      <v-card v-if="isAccept==0">
        お問合せください
      </v-card>

      <v-card v-if="isAccept==1" class="py-2 mt-0 pt-0">
          <v-row dense>
            <v-col cols="12">
              <v-btn
                text
                small
                @click="showDescription3 = !showDescription3"
                class="mt-0 pt-0 mb-2"
              >
                <v-icon color="primary" class="mr-1">{{ showDescription3 ? 'mdi-chat-question-outline' : 'mdi-chat-question' }}</v-icon>オイル分析・診断依頼内容について
              </v-btn>
              <v-expand-transition>
              <v-card flat outlined class="pa-2 mb-6" v-show="showDescription3">
<!--
                <v-card-title class="pa-0 caption">
                  <v-icon class="mr-1" color="primary">mdi-information-outline</v-icon>
                  <span class="primary--text">オイル分析・診断依頼内容について</span>
                </v-card-title>
-->
                <v-card-text class="caption">
                  この機器のオイルを「OilMatrix ジャパン・アナリスト」で依頼いただく際の標準的な分析依頼内容を入力します。<br>
                  この機器のサンプルを採取する際、ここで入力した内容が自動的に入力されます。<br>
                </v-card-text>
              </v-card>
              </v-expand-transition>
            </v-col>
          </v-row>

          <v-row dense class="py-2">
            <v-col cols="10" md="5" class="align-end" dense> 
              <v-tooltip top color="grey darken-3">
                <template v-slot:activator="{ on }">
                  <v-select
                    v-on="on"
                    v-model="AnalizeTypeGroup" 
                    @change="changeAnalizeTypeGroup()" 
                    :label="getItemName('分析方法')[AnalizeTypeCategory+'label']"
                    :items="analizeTypeGroupList" 
                    item-value="Value" 
                    item-text="Text"
                    @input="$v.AnalizeTypeGroup.$touch()"
                    :error-messages="AnalizeTypeGroupErrors"
                    :error="$v.AnalizeTypeGroup.$error"
                    :messages="getItemName('分析方法')[AnalizeTypeCategory + 'message']"
                  >
                  </v-select>
                </template>
                <span>
                分析方法を「社定法」か「公定法」かで選択してください。<br><br>
                <strong>社定法とは...</strong><br>
                弊社の独自法です。安価で短納期です。<br><br>
                <strong>公定法とは...</strong><br>
                公的規格に準拠した方法です。<br>
                ご依頼時に条件がありますので、事前に営業部へご連絡下さい。<br>
                ※分析方法で公定法を選択し、公定法分析項目を選択された場合は、上記注意事項に沿ってご依頼ください。
                </span>
<!--
                <span class="wrap-text">{{getItemName('分析方法')[AnalizeTypeCategory+'description']}}</span>
-->
              </v-tooltip>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <v-col cols="10" md="5" class="align-end" dense> 
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-select
                    v-on="on"
                    v-model="AnalizeType"
                    :label="getItemName('分析区分')[AnalizeTypeCategory+'label']"
                    :items="analizeTypeList"  
                    item-value="Value" 
                    item-text="Text" 
                    no-data-text="分析方法を選択してください。"                    
                    @change="changeAnalizeType"
                    @input="$v.AnalizeType.$touch()"
                    :error-messages="AnalizeTypeErrors"
                    :error="$v.AnalizeType.$error"
                    :messages="getItemName('分析区分')[AnalizeTypeCategory + 'message']"
                    readonly
                  >
                  </v-select>
                </template>
                <span class="wrap-text">{{getItemName('分析区分')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
              <v-chip color="blue" text-color="white" x-small class="px-2">自動</v-chip>                    
            </v-col>

            <v-col cols="12" md="5" class="align-end" dense> 
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-select
                    v-on="on"
                    v-model="AnalizeSet" 
                    clearable
                    @change="changeAnalizeSet" 
                    :label="getItemName('セット分析')[AnalizeTypeCategory+'label']"
                    :items="analizeSetList" 
                    item-value="Value" 
                    item-text="Text" 
                    no-data-text="この分析区分にはセット分析はありません"
                    @input="$v.AnalizeSet.$touch()"
                    :error-messages="AnalizeSetErrors"
                    :error="$v.AnalizeSet.$error"
                    :messages="getItemName('セット分析')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:item="{ item }">
                      <v-checkbox
                      :input-value="AnalizeSet == item.Value"
                      />
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.Description"  class="wrap-text"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </template>
                <span class="wrap-text">{{getItemName('セット分析')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>

            <v-col cols="12" md="11" v-show="isSelectAnalizeSet" dense>
              <v-select
                v-model="analizeSetItems"
                :items="analizeSetItems"
                item-value="Value"
                item-text="Text"
                label="セットに含まれる分析項目"
                multiple
                disabled
                append-icon=""
              >
                <template v-slot:selection="{ item }">
                  <v-chip>
                    <span>{{ item.Text }}</span>
                  </v-chip>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" md="12" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-autocomplete
                    v-on="on"
                    v-model="AnalizeItems" 
                    :items="activeAnalizeItemList" 
                    item-value="Value" 
                    item-text="Text" 
                    :label="getItemName('個別分析項目')[AnalizeTypeCategory+'label']"
                    multiple
                    no-data-text="分析区分を選択してください。"
                    @change="changeAnalizeItems" 
                    @input="$v.AnalizeItems.$touch()"
                    :error-messages="AnalizeItemsErrors"
                    :error="$v.AnalizeItems.$error"
                    :messages="getItemName('個別分析項目')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip
                        color="green darken-3"
                        text-color="white"
                      >
                        <span>{{ item.Text }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-checkbox
                      :input-value="AnalizeItems.includes(item.Value)"
                      />
                      <v-list-item-content>
                        <v-list-item-title v-text="item.Text"></v-list-item-title>
                        <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </template>
                <span class="wrap-text">{{getItemName('個別分析項目')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <template v-for="parent of Object.keys(AnalizeItemSub)">
            <v-row dense class="ml-2" v-bind:key="parent">
              <v-col cols=11 dense class="mb-0 pb-0">
                <v-icon color="blue">mdi-information</v-icon>
                <span class="font-weight-bold">「{{getAnalizeItemName(parent)}}」</span>が選択されました。以下の分析を追加することができます。
              </v-col>
              <v-col cols=11 dense class="ml-6 mb-0 pb-0">
                <v-autocomplete
                  v-model="AnalizeItemSub[parent]" 
                  :items="analizeItemSubList[parent]" 
                  item-value="Value" 
                  item-text="Text" 
                  label="追加項目"
                  class="mb-0 pb-0"
                  @change="changeAnalizeItemSub"
                  :error-messages="AnalizeItemSubError[parent]"
                  multiple
                >
                  <template v-slot:selection="{ item }">
                    <v-chip
                      color="green darken-1"
                      text-color="white"
                    >
                      <span>{{ item.Text }}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-checkbox
                    :input-value="AnalizeItemSub[parent].includes(item.Value)"
                    />
                    <v-list-item-content>
                      <v-list-item-title v-text="item.Text"></v-list-item-title>
                      <v-list-item-subtitle v-html="item.Description" class="wrap-text"></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </template>

<!--
          <v-row dense>
            <v-col>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                <v-textarea
                    v-on="on"
                    v-model="AnalizePurpose"
                    :label="AnalizePurposeLabel"
                    filled
                    counter=256
                    :messages="getItemName('分析目的')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('分析目的')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                </v-textarea>
                </template>
                <span class="wrap-text">{{getItemName('分析目的')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
          </v-row>
-->


          <v-row dense>
            <v-col cols="12" md="12" dense>
                <span class="mr-1">分析項目の詳細は</span>
                <v-btn
                  text
                  color="link"
                  min-height="20"
                  class="x-small align-center py-1 px-2"
                  @click="openWindow(`https://www.japan-analysts.com/analyze/list/`)"
                >
                  <span class="text-left">こちら</span>
                </v-btn>
                <span class="mr-1">からご確認ください。</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="12" dense>
              
            </v-col>
          </v-row>

          <v-row v-show="standardValueList.length">
            <v-col cols="12" lg="3" md='12' sm='12' xs="12" class="align-start" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-switch
                    v-on="on"
                    class="ml-3"
                    v-model="isSwStandard"
                    label="報告書へ分析規格を記載"
                    @change="changeSwStandard"
                  >
                  </v-switch>
                </template>
                <span>分析・診断報告書に分析規格の記載をご希望される場合はチェックしてください。</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" lg="9" md='12' sm='12' xs="12" class="align-start"  v-show="standardValueList.length&&isSwStandard">
              <v-card flat outlined>
                <v-row class="px-4 pt-4" dense>
                  <v-col cols="12" dense>
                    <div>
                      <v-icon color="blue">mdi-information-outline</v-icon>
                      <span class="caption">
                        ジャパン・アナリストで登録済みの分析規格の一覧から選択してください<br>
                        分析規格の追加をご希望の場合は、弊社担当営業までご連絡ください。
                      </span>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="px-6">
                  <v-col cols="10">
                    <v-tooltip top color="grey darken-2">
                      <template v-slot:activator="{ on }">
                        <v-select
                          v-on="on"
                          v-model="StandardValue" 
                          clearable 
                          @change="changeStandardValue" 
                          label="分析規格" 
                          dense 
                          :items="standardValueList" 
                          item-value="Value" 
                          item-text="Text" 
                          no-data-text="この分析区分には分析規格はありません"
                          @input="$v.StandardValue.$touch()"
                          :error-messages="StandardValueErrors"
                          :error="$v.StandardValue.$error"
                        >
                            <template slot='selection' slot-scope='data'>
                              {{ data.item.Text }}
                            </template>
                            <template slot="item" slot-scope="data">
                              {{ data.item.Text }} [ {{ data.item.StandardValue }} ]
                            </template>
                        </v-select>
                      </template>
                      <span>ご希望の分析規格を選択してください。</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="2" align-self="center">
                    <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="6">
              <v-radio-group v-model="Filter">
                <template v-slot:label>
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <div v-on="on">汚染度（質量法）試験後の<strong>フィルター返却</strong></div>
                    </template>
                    <span class="wrap-text">{{getItemName('フィルター返却')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </template>
                <v-radio value="001">
                  <template v-slot:label>
                    <div>不要（0円）</div>
                  </template>
                </v-radio>
                <v-radio value="002">
                  <template v-slot:label>
                    <div>必要。ラミネート加工 <strong class="black--text">あり（1,700円／検体）</strong></div>
                  </template>
                </v-radio>
                <v-radio value="003">
                  <template v-slot:label>
                    <div>必要。ラミネート加工 <strong class="black--text">なし（600円／検体）</strong></div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="6">
              <v-radio-group v-model="Surplus">
                <template v-slot:label>
                  <v-tooltip top color="grey darken-2">
                    <template v-slot:activator="{ on }">
                      <div v-on="on"><strong>着払いで</strong>サンプルの返却</div>
                    </template>
                    <span class="wrap-text">{{getItemName('サンプル返却')[AnalizeTypeCategory+'description']}}</span>
                  </v-tooltip>
                </template>
                <v-radio value="0">
                  <template v-slot:label>
                    <div>返却を希望 しない</div>
                  </template>
                </v-radio>
                <v-radio value="1">
                  <template v-slot:label>
                    <div>返却を希望 （返送には別途手数料が掛ります）</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <template v-if="AnalizeTypeCategory=='航空機'">
            <v-row dense>
              <v-col cols="12" xl="2" lg="2" md='3' sm='3' xs="12" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
<!--
                     :messages="getItemName('サンプル採取場所')[AnalizeTypeCategory + 'message']"
                    :messages="SamplingPlaceMessage"
  -->
                    <v-text-field
                      v-on="on"
                      v-model="SamplingPlace"
                      :label="getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']"
                      :counter="getItemName('サンプル採取場所')[AnalizeTypeCategory+'counter']"
                      @input="$v.SamplingPlace.$touch()"
                      :error-messages="SamplingPlaceErrors"
                      :messages="SamplingPlaceMessage"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('サンプル採取場所')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('サンプル採取場所')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
              </v-col>

              <v-col cols="12" xl="2" lg="2" md='3' sm='3' xs="12" dense>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
<!--
                     :messages="getItemName('サンプル採取場所')[AnalizeTypeCategory + 'message']"
                    :messages="SamplingPlaceMessage"
  -->
                    <v-text-field
                      v-on="on"
                      v-model="SamplingBy"
                      :label="getItemName('採取者')[AnalizeTypeCategory+'label']"
                      :counter="getItemName('採取者')[AnalizeTypeCategory+'counter']"
                      @input="$v.SamplingBy.$touch()"
                      :error-messages="SamplingByErrors"
                      :messages="SamplingByMessage"
                    >
                      <template v-slot:prepend-inner v-if="getItemName('採取者')[AnalizeTypeCategory+'証明書']">
                        <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('採取者')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
              </v-col>
              <v-col cols="2" xl="1" lg="1" md='1' sm='2' xs="2" dense>
              </v-col>

            </v-row>
          </template>

      </v-card>
    </v-stepper-content>

    <div class="ma-3">
      <v-row>
        <v-col cols="9">
        <v-tooltip right color="grey" v-if ="isCreate" >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              rounded
              color="amber"
              @click="confirmCreateMachine"
              data-addMachine
              class="mx-2"
            >
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>マイ機器を登録
            </v-btn>
          </template>
          <span>入力した内容で新しいマイ機器を登録します。</span>
        </v-tooltip>

        <v-tooltip top color="grey" v-else  >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              rounded
              color="amber"
              @click="confirmCreateMachine"
              data-putMachine
              class="mx-2"
            >
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>マイ機器情報を更新
            </v-btn>
          </template>
          <span>入力した内容で新しいマイ機器の情報を更新します。</span>
        </v-tooltip>
<!--
        <v-tooltip top color="grey" activator="#sample_btn2" v-if ="!isCreate" >
          <span>このマイ機器のオイルを採油します</span>
        </v-tooltip>
        <v-btn v-if ="!isCreate"
          rounded
          color="amber"
          :to="{ path:'sampling', query: { id: this.machineid }}"
          class="mx-2"
          id="sample_btn2">
          <v-icon class="mr-2">mdi-cup-water</v-icon>分析サンプルを登録
        </v-btn>
-->
        </v-col>
      <v-col cols="3" class="text-lg-right">
        <v-tooltip top color="grey" v-if ="!isCreate"  >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" slot="activator" rounded color="red white--text" @click="showDialog()" dark data-delMachine>
            <v-icon class="mr-2">mdi-delete-circle</v-icon>
            このマイ機器を削除
            </v-btn>
          </template>
          <span>このマイ機器削除を削除します</span>
        </v-tooltip>

      </v-col>
      
      </v-row>

    </div>

</v-stepper>
    </v-form>

    <v-dialog
      v-model="isConfirmed"
      persistent
      max-width="90%"
    >
      <v-card class="px-3 py-2">
        <v-card-title class="headline">
          <v-icon class="mr-1" color="primary" large>mdi-information-outline</v-icon>
          {{ isCreate ?  "登録" : "更新" }}内容をご確認ください
          </v-card-title>
        <v-card-text> 
          下記の登録内容をご確認のうえ、「マイ機器を{{ isCreate ?  "登録" : "更新" }}」ボタンをクリックしてください
          
          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              {{machineTypeText}}情報
            </v-card-title>

            <v-card-text>
            <template v-if="mountedMachine">
              <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器名_機体')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.Name}}
                    <template v-if="!mountedMachine.Name">-</template>
                  </div>
                </v-col>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ_機体')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.CustomerMachineID}}
                    <template v-if="!mountedMachine.CustomerMachineID">-</template>
                  </div>
                </v-col>
-->
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離_機体')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.TotalOperatingTime}} {{mountedMachine.TotalOperatingTimeUnitText}}
                    <template v-if="!mountedMachine.TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('修理後使用時間／距離_機体')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{mountedMachine.SinceOverhaulTime}} {{mountedMachine.SinceOverhaulTimeUnitText}}
                    <template v-if="!mountedMachine.SinceOverhaulTime">-</template>
                  </div>
                </v-col>
-->
              </v-row>
            </template>

              <v-row dense class="pa-2">
                <template v-if="AnalizeTypeCategory == '一般'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('マイ機器名')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="caption grey lighten-3 pl-2">
                      {{getItemName('マイ機器名')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{Name}}
                      <template v-if="!Name">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器ＩＤ')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{CustomerMachineID}}
                    <template v-if="!CustomerMachineID">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機械名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機械名')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{Equipment}}
                    <template v-if="!Equipment">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '一般'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('顧客名')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('顧客名')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{CustomerName}}
                      <template v-if="!CustomerName">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('製造メーカー名')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MakerText}}
                    <template v-if="!MakerText">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('型式')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{ModelNumber}}
                    <template v-if="!ModelNumber">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('機器導入日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{PurchasedDate}}
                    <template v-if="!PurchasedDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('累計使用時間／距離')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{TotalOperatingTime}} {{TotalOperatingTimeUnitText}}
                    <template v-if="!TotalOperatingTime">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '航空機'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0" >
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理日')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理日')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{OverhaulDate}}
                      <template v-if="!OverhaulDate">-</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{SinceOverhaulTime}} {{SinceOverhaulTimeUnitText}}
                      <template v-if="!SinceOverhaulTime">-</template>
                    </div>
                  </v-col>
                </template>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('システム油量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('システム油量')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SystemOil}} {{SystemOilUnitText}}
                    <template v-if="!SystemOil">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('マイ機器メモ')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{MachineMemo}}
                    <template v-if="!MachineMemo">-</template>
                  </div>
                </v-col>

              </v-row>

            </v-card-text>
          </v-card>

          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              使用オイル情報
            </v-card-title>
            <v-card-text>
              <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイルの種類')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilTypeCategoryText}}／{{OilTypeText}} {{OilPropertyText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('使用オイル')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilmakerText}}／{{OilModelNumber}} {{OilGradeText}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換日')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChangeDate}}
                    <template v-if="!OilChangeDate">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル交換量')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilChange}} {{OilChangeUnitText}}
                    <template v-if="!OilChange">-</template>
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('オイル使用時間')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{OilUsageTime}} {{OilUsageTimeUnitText}}
                    <template v-if="!OilUsageTime">-</template>
                  </div>
                </v-col>

                <template v-if="AnalizeTypeCategory == '航空機'">
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      <template v-if="UseFilter == undefined">使用していない</template>
                      <template v-else-if="!UseFilter">使用していない</template>
                      <template v-else-if="UseFilter">使用している</template>
                    </div>
                  </v-col>

                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用時間')[AnalizeTypeCategory+'label']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="subtitle-2 grey lighten-3 pl-2">
                      {{getItemName('フィルター使用時間')[AnalizeTypeCategory + 'message']}}
                    </div>
                  </v-col>
                  <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                    <div class="body-1  font-weight-bold pl-2">
                      {{FilterUsageTime}} {{FilterUsageTimeUnitText}}
                      <template v-if="!FilterUsageTime">-</template>
                    </div>
                  </v-col>
                </template>
<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル採取場所')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル採取場所')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{SamplingPlace}}
                    <template v-if="!SamplingPlace">-</template>
                  </div>
                </v-col>
-->
              </v-row>
            </v-card-text>
          </v-card>

          <v-card outlined flat class="mb-3">
            <v-card-title class="teal darken-1 pa-2 mb-1 white--text">
              オイル分析診断内容
            </v-card-title>
            <v-card-text>
              <v-row dense class="pa-2">
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析方法')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析方法')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeTypeGroup}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析区分')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析区分')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeTypeName}}
                  </div>
                </v-col>

                <!-- <v-col cols="3"  lg="3" md='3' sm='6' xs="6">
                  <v-text-field v-model="StandardValueName" label="分析規格" dense readonly></v-text-field>
                </v-col> -->

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('セット分析')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{AnalizeSetName}}
                    <template v-if="!AnalizeSetName">-</template>
                  </div>
                </v-col>

                <v-col cols="12" v-show="isSelectAnalizeSet">
                  <v-select
                    v-model="analizeSetItems"
                    :items="analizeSetItems"
                    item-value="Value"
                    item-text="Text"
                    label="セットに含まれる分析項目"
                    multiple
                    disabled
                    append-icon=""
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip>
                        <span>{{ item.Text }}</span>
                      </v-chip>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('個別分析項目')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('個別分析項目')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pt-0">
                  <template v-for="(item, index) in analizeItemNames">
                    <v-chip small color="green" class="white--text ml-2 mb-1" :key="index"> {{item}}</v-chip>
                  </template>
                </v-col>



                <v-col cols="1" lg="2" md="3" sm='12' xs="12" v-show="standardValueList.length">
                  <span class="caption">報告書へ規格の記載：</span>
                  <span v-if="isSwStandard">記載する</span>
                  <span v-if="!isSwStandard">記載しない</span>
                </v-col>
                <v-col cols="12" lg="10" md="9" sm='12' xs="12" v-show="standardValueList.length">
                  <v-text-field v-if="isSwStandard" v-model="StandardValueName" label="記載する分析規格" dense readonly></v-text-field>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('フィルター返却')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('フィルター返却')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{getFilterText(Filter)}}
                  </div>
                </v-col>

                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル返却')[AnalizeTypeCategory+'label']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('サンプル返却')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="body-1  font-weight-bold pl-2">
                    {{getSurplusText(Surplus)}}
                  </div>
                </v-col>

<!--
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{AnalizePurposeLabel}}
                  </div>
                </v-col>
                <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
                  <div class="subtitle-2 grey lighten-3 pl-2">
                    {{getItemName('分析目的')[AnalizeTypeCategory + 'message']}}
                  </div>
                </v-col>
                <v-col cols="12" xl="8" lg="6" md='4' sm='12' xs="12" dense class="pt-0">
                  {{AnalizePurpose}}
                  <template v-if="!AnalizePurpose">-</template>
                </v-col>
-->
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
        <v-tooltip top color="grey darken-2">
          <template v-slot:activator="{ on }">
          <v-btn
            color="grey darken-4"
            v-on="on"
            outlined
            rounded
            elevation="2"
            @click="isConfirmed = false"
          >
            キャンセル
          </v-btn>
          </template>
          <span>マイ機器情報を修正します</span>
        </v-tooltip>

        <v-tooltip top color="grey" v-if ="isCreate" >
          <template v-slot:activator="{ on }">
          <v-btn 
            rounded 
            v-on="on"
            color="amber darken-1" 
            :disabled="processing"
            @click="createMachine()" 
            data-createApplication 
            class="px-2">
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              マイ機器を登録
          </v-btn> 
          </template>
          <span>新しいマイ機器情報を登録します</span>
        </v-tooltip>

        <v-tooltip top color="grey" v-else >
          <template v-slot:activator="{ on }">
          <v-btn 
            v-on="on"
            rounded 
            color="amber darken-1" 
            :disabled="processing"
            @click="createMachine()" 
            data-updateApplication 
            class="px-2">
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              マイ機器を更新
          </v-btn> 
          </template>
          <span>マイ機器情報を更新します</span>
        </v-tooltip>


        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isUsageTimeUpdate"
      persistent
      min-width="800px"
      max-width="70%"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="px-3 py-2">
        <v-card-title>
          使用時間を更新する
        </v-card-title>
        <v-card-subtitle class="pt-2 pb-3">
          この機器の使用時間を更新します。<br>
          <template v-if="AnalizeTypeCategory == '航空機'">
            <template v-if="!UseFilter">
            {{getItemName('フィルター使用時間')[AnalizeTypeCategory+'label']}}はフィルター使用時のみ更新できます。<br>
            </template>
            <template v-if="!OverhaulDate"> 
            {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']}}は{{getItemName('修理日')[AnalizeTypeCategory+'label']}}が設定されている場合のみ更新できます。<br>
            </template>
          </template>
          <br>
        </v-card-subtitle>
        <v-card-text>
          <v-row dense>
            <v-col cols=12 dense>
              <v-checkbox
                v-model="syncUsageTime"
                label="以下のすべての使用時間に反映する"
                class="caption my-0 py-0"
                dense
                @click="changeSyncUsageTime"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row dense class="mb-3">
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0">
              <v-text-field
                :disabled="!syncUsageTime"
                v-model="usageTime"
                label="追加する使用時間／距離"
                @input="calcUsageTime()"
                :error-messages="usageTimeErrors"
                class="mb-0">
              </v-text-field>
            </v-col>

          </v-row>
          <v-row dense>
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12" dense class="pa-0 font-weight-bold">
              <div class="subtitle-2 grey darken-2 white--text font-weight-bold pl-2 ">
              項目名
              </div>
            </v-col>
            <v-col cols="12" xl="2" lg="3" md='3' sm='3' xs="12" dense class="pa-0 font-weight-bold d-none d-sm-block">
              <div class="subtitle-2 grey darken-2 white--text font-weight-bold text-center pl-2 ">
              現在の時間／距離
              </div>
            </v-col>
            <v-col cols="12" xl="8" lg="6" md='4' sm='9' xs="12" dense class="pa-0 font-weight-bold">
              <div class="subtitle-2 grey darken-2 white--text font-weight-bold pl-2 ">
              更新する時間／距離
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12"  class="font-weight-bold title">
              <div>
              {{getItemName('累計使用時間／距離')[AnalizeTypeCategory+'label']}}
              </div>
              <div class="caption pl-2">
              {{getItemName('累計使用時間／距離')[AnalizeTypeCategory + 'message']}}
              </div>
            </v-col>
            <v-col cols="12" xl="2" lg="3" md='3' sm='4' xs="4" class="d-none d-sm-block">
              <div v-if="TotalOperatingTime" class="title font-weight-regular pr-4 text-right">
                {{TotalOperatingTime}}
                <template v-if="AnalizeTypeCategory!='航空機'">
                    {{TotalOperatingTimeUnitText}}
                </template>
                <v-icon v-if="syncUsageTime" class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
              </div>
              <div v-else class="caption pl-2">
                ―
              </div>
            </v-col>
            <v-col cols="6" xl="2" lg="3" md='2' sm='4' xs="4">
              <template v-if="!syncUsageTime">
                <v-text-field
                  v-model="newTotalOperatingTime"
                  class="pl-2"
                  @input="$v.newTotalOperatingTime.$touch()"
                  :error-messages="newTotalOperatingTimeErrors"
                  dense>
                </v-text-field>
              </template>
              <template v-else>
                <div class="title text-right">
                {{ newTotalOperatingTime}}</div>
              </template>
            </v-col>
            <v-col cols="6" xl="2" lg="2" md='2' sm='4' xs="6">
              <template v-if="AnalizeTypeCategory!='航空機'">
                <template v-if="!syncUsageTime">
                  <v-select
                    v-model="newTotalOperatingTimeUnit"
                    label="単位"
                    dense
                    :items="useUnits"
                    item-value="Value"
                    item-text="Text"
                    clearable
                    @change="changeNewTotalOperatingTimeUnit()"
                  ></v-select>
                </template>
                <template v-else>
                  <div class="title">
                  {{ newTotalOperatingTimeUnitText}}</div>
                </template>
              </template>
            </v-col>
          </v-row>


          <v-row v-if="OverhaulDate">
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12"  class="font-weight-bold title">
              <div>
              {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']}}
              </div>
              <div class="caption pl-2">
              {{getItemName('修理後使用時間／距離')[AnalizeTypeCategory + 'message']}}
              </div>
            </v-col>
            <v-col cols="12" xl="2" lg="3" md='3' sm='4' xs="4" class="d-none d-sm-block">
              <div v-if="SinceOverhaulTime" class="title font-weight-regular pr-4 text-right">
                {{SinceOverhaulTime}}
                <template v-if="AnalizeTypeCategory!='航空機'">
                  {{SinceOverhaulTimeUnitText}}
                </template>
                <v-icon v-if="syncUsageTime" class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
              </div>
              <div v-else class="caption pl-2">
                ―
              </div>
            </v-col>
            <v-col cols="6" xl="2" lg="3" md='2' sm='4' xs="4">
              <template v-if="!syncUsageTime">
                <v-text-field
                  v-model="newSinceOverhaulTime"
                  class="pl-2"
                  @input="$v.newSinceOverhaulTime.$touch()"
                  :error-messages="newSinceOverhaulTimeErrors"
                  dense>
                </v-text-field>
                </template>
                <template v-else>
                  <div class="title text-right">
                  {{ newSinceOverhaulTime}}</div>
                </template>
            </v-col>
            <v-col cols="6" xl="2" lg="2" md='2' sm='2' xs="6">
              <template v-if="AnalizeTypeCategory!='航空機'">
                <template v-if="!syncUsageTime">
                  <v-select
                    v-model="newSinceOverhaulTimeUnit"
                    label="単位"
                    dense
                    :items="useUnits"
                    item-value="Value"
                    item-text="Text"
                    clearable
                    @change="changeNewSinceOverhaulTimeUnit()"
                  ></v-select>
                </template>
                <template v-else>
                  <div class="title">
                  {{ newSinceOverhaulTimeUnitText}}</div>
                </template>
              </template>
            </v-col>
          </v-row>

          <v-row >
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12"  class="font-weight-bold title">
              <div>
              {{getItemName('オイル使用時間')[AnalizeTypeCategory+'label']}}
              </div>
              <div class="caption pl-2">
              {{getItemName('オイル使用時間')[AnalizeTypeCategory + 'message']}}
              </div>
            </v-col>
            <v-col cols="12" xl="2" lg="3" md='3' sm='4' xs="4" class="d-none d-sm-block">
              <div v-if="OilUsageTime" class="title font-weight-regular pr-4 text-right">
                {{OilUsageTime}}
                <template v-if="AnalizeTypeCategory!='航空機'">
                  {{OilUsageTimeUnitText}}
                </template>
                <v-icon v-if="syncUsageTime" class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
              </div>
              <div v-else class="caption pl-2">
                ―
              </div>
            </v-col>
            <v-col cols="6" xl="2" lg="3" md='2' sm='4' xs="4">
              <template v-if="!syncUsageTime">
                <v-text-field
                  v-model="newOilUsageTime"
                  class="pl-2"
                  @input="$v.newOilUsageTime.$touch()"
                  :error-messages="newOilUsageTimeErrors"
                  dense>
                </v-text-field>
              </template>
              <template v-else>
                <div class="title text-right">
                {{ newOilUsageTime}}</div>
              </template>
            </v-col>
            <v-col cols="6" xl="2" lg="2" md='2' sm='4' xs="6">
              <template v-if="AnalizeTypeCategory!='航空機'">
                <template v-if="!syncUsageTime">
                  <v-select
                    v-model="newOilUsageTimeUnit"
                    label="単位"
                    dense
                    :items="useUnits"
                    item-value="Value"
                    item-text="Text"
                    clearable
                    @change="changeNewOilUsageTimeUnit()"
                  ></v-select>
                </template>
                <template v-else>
                  <div class="title">
                  {{ newOilUsageTimeUnitText}}</div>
                </template>
              </template>
            </v-col>
          </v-row>

          <v-row v-if="UseFilter">
            <v-col cols="12" xl="2" lg="3" md='4' sm='12' xs="12"  class="font-weight-bold title">
              <div>
              {{getItemName('フィルター使用時間')[AnalizeTypeCategory+'label']}}
              </div>
              <div class="caption pl-2">
              {{getItemName('フィルター使用時間')[AnalizeTypeCategory + 'message']}}
              </div>
            </v-col>
            <v-col cols="12" xl="2" lg="3" md='3' sm='4' xs="4" class="d-none d-sm-block">
              <div v-if="FilterUsageTime" class="title font-weight-regular pr-4 text-right">
                {{FilterUsageTime}}
                <template v-if="AnalizeTypeCategory!='航空機'">
                  {{FilterUsageTimeUnitText}}
                </template>
                <v-icon v-if="syncUsageTime" class="mr-2" color="blue">mdi-arrow-right-bold</v-icon>
              </div>
              <div v-else class="caption pl-2">
                ―
              </div>
            </v-col>
            <v-col cols="6" xl="2" lg="3" md='2' sm='4' xs="4">
              <template v-if="!syncUsageTime">
                <v-text-field
                  v-model="newFilterUsageTime"
                  class="pl-2"
                  @input="$v.newFilterUsageTime.$touch()"
                  :error-messages="newFilterUsageTimeErrors"
                  dense>
                </v-text-field>
              </template>
              <template v-else>
                <div class="title text-right">
                {{ newFilterUsageTime}}</div>
              </template>
            </v-col>
            <v-col cols="6" xl="1" lg="2" md='2' sm='2' xs="6">
              <template v-if="AnalizeTypeCategory!='航空機'">
                <template v-if="!syncUsageTime">
                  <v-select
                    v-model="newFilterUsageTimeUnit"
                    label="単位"
                    dense
                    :items="useUnits"
                    item-value="Value"
                    item-text="Text"
                    clearable
                    @change="changeNewFilterUsageTimeUnit()"
                  ></v-select>
                </template>
                <template v-else>
                  <div class="title">
                  {{ newFilterUsageTimeUnitText}}</div>
                </template>
              </template>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="isUsageTimeUpdate = false"
          >
            キャンセル
          </v-btn>

          <v-btn 
            rounded 
            color="amber darken-1" 
            :disabled="processing"
            data-createApplication 
            @click="updateUsageTime()"
            class="px-2">
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              更新
          </v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="isOverhaulUpdate"
      persistent
      max-width="50%"
    >
      <v-card class="px-3 py-2">
        <v-card-title>
          オーバーホール歴を登録する
        </v-card-title>
        <v-card-subtitle>
          この機器の{{getItemName('修理日')[AnalizeTypeCategory+'label']}}と{{getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']}}を更新します。
        </v-card-subtitle>
        <v-card-text>
          <v-row dense>
            <v-col cols="3" xl="2" lg="3" md='3' sm='3' xs="3" dense class="pa-0">
              <v-menu
                v-model="newOverhaulDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newOverhaulDate"
                    :label="getItemName('修理日')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    dense
                    @input="$v.newOverhaulDate.$touch()"
                    :error-messages="newOverhaulDateErrors"
                    :messages="getItemName('修理日')[AnalizeTypeCategory + 'message']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newOverhaulDate"
                  @input="newOverhaulDatePicker = false"
                  locale="ja"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="3" xl="2" lg="3" md='3' sm='3' xs="3" dense class="pa-0">
              <v-text-field
                v-model="newSinceOverhaulTime"
                :label="getItemName('修理後使用時間／距離')[AnalizeTypeCategory+'label']"
                dense
                @input="$v.newSinceOverhaulTime.$touch()"
                :error-messages="newSinceOverhaulTimeErrors"
                :messages="getItemName('修理後使用時間／距離')[AnalizeTypeCategory + 'message']"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3" xl="2" lg="3" md='3' sm='3' xs="3" dense class="pa-0">
              <template v-if="AnalizeTypeCategory!='航空機'">
                <v-select
                  v-model="newSinceOverhaulTimeUnit"
                  label="単位"
                  dense
                  :items="useUnits"
                  item-value="Value"
                  item-text="Text"
                  clearable
                  @change="changeNewSinceOverhaulTimeUnit()"
                ></v-select>
                </template>
            </v-col>
          </v-row>

          <v-row dense class="mt-5">
            <v-col cols="12" class="pa-0">
              <span class="caption">{{getItemName('修理メモ')[AnalizeTypeCategory+'label']}}</span>
                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                    <v-textarea
                      v-model="OverhaulMemo"
                      label="修理メモ"
                      filled
                      counter=256
                      v-on="on"
                    ></v-textarea>
                  </template>
                  <span class="wrap-text">{{getItemName('修理メモ')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>
            </v-col>
          </v-row>


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="closeUpdateOverhaul"
          >
            キャンセル
          </v-btn>

          <v-btn 
            rounded 
            color="amber darken-1" 
            :disabled="processing"
            data-createApplication 
            @click="updateOverhaulDate()"
            class="px-2">
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              更新
          </v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="isOilChangeUpdate"
      persistent
      max-width="80%"
    >
      <v-card class="px-3 py-2">
        <v-card-title>
          オイル交換する
        </v-card-title>
        <v-card-subtitle>
          使用オイル情報とオイル使用時間を更新します
        </v-card-subtitle>
        <v-card-text>
          <v-row dense>
            <v-col cols="3" xl="2" lg="3" md='3' sm='3' xs="3" dense class="pa-0">
              <v-menu
                v-model="newOilChangeDatePicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                bottom
                :offset-y=true
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newOilChangeDate"
                    :label="getItemName('オイル交換日')[AnalizeTypeCategory+'label']"
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @input="$v.newOilChangeDate.$touch()"
                    :error-messages="newOilChangeDateErrors"
                    :messages="getItemName('オイル交換日')[AnalizeTypeCategory + 'message']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newOilChangeDate"
                  @input="newOilChangeDatePicker = false"
                  locale="ja"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" md="12" class="mb-2" dense> 
              <span class="caption">
                <v-icon color="blue" class="mr-2">mdi-information</v-icon>
                現在使用しているオイル情報がプリセットされています。新しいオイル情報を入力してください。
              </span>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="6" md="6" class="align-end" dense> 
              <v-text-field
                v-model="newOilmakerID"
                :label="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'label']"
                :counter=20
                @input="$v.newOilmakerID.$touch()"
                @blur="$v.newOilmakerID.$touch()"
                :error-messages="newOilmakerIDErrors"
                :messages="getItemName('使用オイルメーカー')[AnalizeTypeCategory + 'message']"
                >
                <template v-slot:prepend-inner v-if="getItemName('使用オイルメーカー')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>

            <v-col cols="6" md="6" class="align-end" dense> 
              <v-text-field
                v-model="newOilModelNumber"
                :label="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'label']"
                :counter="getItemName('使用オイル銘柄')[AnalizeTypeCategory + 'counter']"
                @input="$v.newOilModelNumber.$touch()"
                @blur="$v.newOilModelNumber.$touch()"
                :error-messages="newOilModelNumberErrors"
                :messages="getItemName('使用オイル銘柄')[AnalizeTypeCategory + 'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('使用オイル銘柄')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="1" lg="1" md='1' sm='2' xs="2" align-self="center" dense>
              <v-chip color="red" text-color="white" x-small class="px-2">必須</v-chip>                    
            </v-col>
<!--
            <v-col cols="10" md="3" class="align-end" dense> 
              <v-select
                v-model="newOilGrade"
                :label="getItemName('使用オイルグレード')[AnalizeTypeCategory+'label']"
                :items="oilGradeList"
                item-value="Value"
                item-text="Text"
                :messages="getItemName('使用オイルグレード')[AnalizeTypeCategory + 'message']"
              >
                <template v-slot:prepend-inner v-if="getItemName('使用オイルグレード')[AnalizeTypeCategory+'証明書']">
                  <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                </template>
              </v-select>
            </v-col>
-->
          </v-row>

          <v-row dense>
            <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="newOilChange"
                    :label="getItemName('オイル交換量')[AnalizeTypeCategory+'label']"
                    @input="$v.newOilChange.$touch()"
                    :error-messages="newOilChangeErrors"
                    :messages="getItemName('オイル交換量')[AnalizeTypeCategory + 'message']"
                  >
                    <template v-slot:prepend-inner v-if="getItemName('オイル交換量')[AnalizeTypeCategory+'証明書']">
                      <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <span class="wrap-text">{{getItemName('オイル交換量')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="4" xl="2" lg="2" md='2' sm='4' xs="4" dense>
              <v-select
                v-model="newOilChangeUnit"
                label="単位"
                :items="liquidUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeNewOilChangeUnit()"
              ></v-select>
            </v-col>
            <v-col cols="1"  lg="1" md='1' sm='2' xs="2" dense>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" xl="2" lg="3" md='4' sm='5' xs="6" class="align-end" dense>
              <v-text-field
                v-model="newOilUsageTime"
                :label="getItemName('オイル使用時間')[AnalizeTypeCategory+'label']"
                @input="$v.newOilUsageTime.$touch()"
                :error-messages="newOilUsageTimeErrors"
                :messages="getItemName('オイル使用時間')[AnalizeTypeCategory + 'message']"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" xl="2" lg="2" md='2' sm='4' xs="4" dense>
              <v-select
                v-model="newOilUsageTimeUnit"
                label="単位"
                :items="useUnits"
                item-value="Value"
                item-text="Text"
                clearable
                @change="changeNewOilUsageTimeUnit()"
              ></v-select>
            </v-col>
          </v-row>

          <v-row dense class="mt-5">
            <v-col cols="12" class="pa-0">
              <span class="caption">{{getItemName('オイル交換メモ')[AnalizeTypeCategory+'label']}}</span>
              <v-tooltip top color="grey darken-2">
                <template v-slot:activator="{ on }">
                  <v-textarea
                    v-model="OilChangeMemo"
                    filled
                    counter=256
                    v-on="on"
                  ></v-textarea>
                </template>
                <span class="wrap-text">{{getItemName('オイル交換メモ')[AnalizeTypeCategory+'description']}}</span>
              </v-tooltip>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="closeUpdateOilChange"
          >
            キャンセル
          </v-btn>

          <v-btn 
            rounded 
            color="amber darken-1" 
            :disabled="processing"
            data-createApplication 
            class="px-2"
            @click="updateOilChange()"
          >
              <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
              更新
          </v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="isMountMachine"
      persistent
      width="auto"
      max-width="70%"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="px-3 py-2">
        <v-card-title>
          機体に関連付ける
          <v-spacer></v-spacer>
          <v-icon @click="isMountMachine = false" class="my-3 mx-2">mdi-close-circle </v-icon>
        </v-card-title>
        <v-card-subtitle>
          この装備品を機体に関連付けて管理します。
        </v-card-subtitle>
        <v-card-text>

          <v-stepper
            v-model="se6"
            vertical
            editable
            class="ma-0"
          >
            <v-stepper-step :complete="se6 > 1" step="1" editable color="teal darken-1" class="ma-0 pa-2">
              機体を選択する
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-row>
                <v-col cols=12>
                  <v-data-table
                    :headers="mountMachinesHeader"
                    :items="mountMachines"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    @page-count="pageCount = $event"
                    no-data-text="機体が登録されていません"                    
                    hide-default-footer
                    dense
                    @click:row="selectMountMachine"
                  >
                    <template v-slot:[`item.mounted`]="{ item }">
                      <template v-if="mountedMachine && item.id == mountedMachine.id">
                        <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                      </template>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="10" md='10' sm='12'>
                  <v-pagination
                    v-model="page"
                    :total-visible="totalVisible"
                    :length="pageCount"
                    color="amber black--text"
                    light 
                    circle
                  >
                  </v-pagination>
                </v-col>
                <v-col cols="2"  lg="2"  md='2' sm='4' xs="2">
                  <v-select
                    :value="itemsPerPage"
                    :items = "itemsPerPageList"
                    label="1ページの行数"
                    @input="itemsPerPage = $event"
                  ></v-select>
                </v-col>
              </v-row>



            </v-stepper-content>

            <v-stepper-step :complete="se6 > 2" step="2" color="teal darken-1" class="ma-0 pa-2">
              機体に関連付ける
            </v-stepper-step>
            <v-stepper-content step="2" >

              <v-card flat v-if="mountMachine" class="ma-0 pa-0">
                <v-card-title class="body-1 ma-0 pa-0">
                  <div v-if="!mountedMachine">
                    {{mountMachine.Name}} をこの機体に関連づけますか？<br>
                  </div>
                  <div v-if="mountedMachine && mountedMachine.id != mountMachine.id" class="body-1">
                    現在 {{mountedMachine.Name}} に関連づいています。<br>
                    関連付けを変更しますか？
                  </div>
                  <div v-if="mountedMachine && mountedMachine.id == mountMachine.id" class="body-1">
                    すでに {{mountedMachine.Name}} に関連づいています。<br>
                    搭載位置を変更しますか？
                  </div>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" xl="4" lg="4" md='6' sm='12' xs="12" dense>
                      <v-card flat outlined class="grey lighten-4 white--text" height=100%>
                        <v-card-title class="body-1 py-0 px-2 grey">
                          現在関連づいている機体
                        </v-card-title>
                        <v-card-text class="pt-2">
                          <template  v-if="mountedMachine">
                            {{mountedMachine.Name}}<br>
                            {{mountedMachine.CustomerMachineID}}
                          </template>
                          <template v-else>
                            ありません
                          </template>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" xl="4" lg="4" md='6' sm='12' xs="12" dense>
                      <v-card flat outlined height=100%>
                        <v-card-title class="body-1 py-0 px-2 teal darken-1 white--text">
                          新しく関連付ける機体
                        </v-card-title>
                        <v-card-text class="pt-2">
                          {{mountMachine.Name}}<br>
                          {{mountMachine.CustomerMachineID}}<br>

                <v-tooltip top color="grey darken-2">
                  <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            v-model="MountPosition"
                            :label="getItemName('搭載位置')[AnalizeTypeCategory+'label']"
                            counter=2
                            @input="$v.MountPosition.$touch()"
                            :error-messages="MountPositionErrors"
                            :messages="getItemName('搭載位置')[AnalizeTypeCategory + 'message']"
                          >
                            <template v-slot:prepend-inner v-if="getItemName('搭載位置')[AnalizeTypeCategory+'証明書']">
                              <v-icon color="grey darken-4" small>mdi-certificate-outline</v-icon>
                            </template>
                          </v-text-field>
                  </template>
                  <span class="wrap-text">{{getItemName('搭載位置')[AnalizeTypeCategory+'description']}}</span>
                </v-tooltip>

                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="grey darken-4"
                    outlined
                    rounded
                    elevation="2"
                    @click="isMountMachine = false"
                  >
                    キャンセル
                  </v-btn>

                  <v-btn 
                    rounded 
                    color="amber darken-1" 
                    :disabled="processing"
                    data-createApplication 
                    @click="updateMountMachine()"
                    class="px-2">
                      <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                      関連付ける
                  </v-btn> 
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper>


        </v-card-text>

      </v-card>
    </v-dialog>


    <v-dialog
      v-model="isUnMountMachine"
      persistent
      width="auto"
      max-width="30%"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card class="px-3 py-2">
        <v-card-title>
          機体の関連付けを解除する
        </v-card-title>
        <v-card-subtitle>
          この装備品の機体との関連付けを解除します。
        </v-card-subtitle>
        <v-card-text>
          <v-card flat outlined v-if="mountedMachine" class="grey lighten-4 white--text" height=180px>
            <v-card-title class="body-1 py-0 px-2 grey">
              現在関連づいている機体
            </v-card-title>
            <v-card-text>
              {{mountedMachine.Name}}<br>
              {{mountedMachine.CustomerMachineID}}
              {{mountedMachine.Position}}
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row dense>
            <v-col dense>
              <v-btn
                rounded
                small
                color="grey darken-4"
                outlined
                elevation="2"
                @click="isUnMountMachine = false"
              >
                キャンセル
              </v-btn>
            </v-col>
            <v-col dense>
              <v-btn 
                rounded 
                small
                color="amber darken-1" 
                :disabled="processing"
                data-createApplication 
                @click="UnmountMachine()"
                class="px-2">
                  <v-icon class="mr-2">mdi-checkbox-marked-circle</v-icon>
                  関連付けを解除する
              </v-btn> 
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successMountMachine"
      persistent
      max-width="30%"
    >
      <v-card class="px-3 py-2">
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          装備品を関連付けました。
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="successMountMachine = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successUnMountMachine"
      persistent
      max-width="30%"
    >
      <v-card class="px-3 py-2">
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          装備品の関連付けを解除ました。
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="successUnMountMachine = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successUsageTimeUpdate"
      persistent
      max-width="30%"
    >
      <v-card class="px-1 py-1">
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          使用時間を更新しました
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="successUsageTimeUpdate = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successOverhaulUpdate"
      persistent
      max-width="30%"
    >
      <v-card class="px-1 py-1">
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          オーバーホール歴を登録しました
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="successOverhaulUpdate = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="successOilChangeUpdate"
      persistent
      max-width="30%"
    >
      <v-card class="px-1 py-1">
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          オイル交換歴を登録しました
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            outlined
            rounded
            elevation="2"
            @click="successOilChangeUpdate = false"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="successCreateMachine"
      persistent
      max-width="50%"
    >
      <v-card v-if="isCreate" >
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          新しい{{machineTypeText}}を登録しました。
          <div class="my-3 text-left">
            <v-card outlined max-width="90%" class="mx-auto" color="amber lighten-5">
              <v-card-title>
                <v-icon>mdi-qrcode</v-icon>
                <span class="title font-weight-light">マイ機器QRコードを印刷しましょう</span>          
              </v-card-title>
              <v-card-text class="body-2">
                <p class="body-1">機器専用のQRコードをご用意しました。</p>
                このQRコードをスマートフォンやタブレットから読み取ると「分析サンプルの採取登録」画面にダイレクトにアクセスすることができます。<br>
                機器からサンプルを採取したその場ですぐに登録することができるので、採油作業の効率アップになります。<br>
                ぜひ、ご活用ください
              </v-card-text>
            </v-card>

            <div v-if="!mountedMachine && AnalizeTypeCategory=='航空機'"  class="my-3 text-left">
              <v-card outlined max-width="90%" class="mx-auto" color="blue lighten-5">
                <v-card-title>
                  <span class="title font-weight-light">機体に関連付けましょう</span>          
                </v-card-title>
                <v-card-text class="body-2">
                  <p class="body-1">登録した装備品は機体に関連付けできます。</p>
                  「{{machineTypeText}}情報を見る」ボタンをクリックして「機体に関連付ける」を行ってください。<br>
                  機体を装備品を関連付けることで、機体に関する情報が分析依頼に設定されます。<br>
                  ぜひ、ご活用ください
                </v-card-text>
              </v-card>
            </div>

          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="amber darken-1"
            rounded
            :to="{ path: 'mymachineqrcode/', query: { id: this.machineid, name: this.Name, type: this.Type, machineid: this.CustomerMachineID, PurchasedDate: this.PurchasedDate  }}"
            class="mb-5 mr-3"
          >
            <span class="px-2">
              <v-icon small>mdi-qrcode</v-icon>
              機器のQRコードを印刷
            </span>
          </v-btn>
          <v-btn
            color="amber darken-1"
            rounded
            @click="toUpdateMachine"
            class="mb-5 mr-3"
          >
            <span class="px-2">
              <v-icon small>mdi-engine</v-icon>
              {{machineTypeText}}情報を見る
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="!isCreate" >
         <v-card-text class="text-center">
          <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
          {{machineTypeText}}情報を更新しました。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="amber darken-1"
            rounded
            @click="back"
            class="mb-5 mr-3"
          >
            <span class="px-2">
              <v-icon small>mdi-arrow-left </v-icon>
              戻る
            </span>
          </v-btn>

          <v-btn
            color="amber darken-1"
            rounded
            @click="toUpdateMachine"
            class="mb-5 mr-3"
          >
            <span class="px-2">
              <v-icon small>mdi-engine</v-icon>
              {{machineTypeText}}情報を見る
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>

  <!-- dialogコール -->
  <app-dialog :failureUrl="failureUrl" ref="isFailured"></app-dialog>
  <suc-dialog :successText="successText" :successUrl="successUrl" ref="isSuccessed"></suc-dialog>
  <!--
  <msuc-dialog :successText="successText" :successUrl="successUrl" ref="isMSuccessed"></msuc-dialog>
  -->
  <vali-dialog :valiErrorText="valiErrorText" ref="isErrored"></vali-dialog>
  <deleteMachineconfirm :machineid="machineid" :Name="Name" :CustomerMachineID="CustomerMachineID" ref="deletedialog"></deleteMachineconfirm>
  <!-- <deleteMachineconfirm :Name="Name" :CustomerMachineID="CustomerMachineID" ref="deletedialog"></deleteMachineconfirm> -->
  <machineLogDialog ref="machineLog"></machineLogDialog>

  </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { createMachine, updateMachine, deleteMachine } from "../graphql/mutations"
import { createMachineLog } from "../graphql/mutations"
import { required, maxLength, numeric, alphaNum } from 'vuelidate/lib/validators'
import validations from '../utils/validations.js'
import mixin from '../utils/mixin.js'
import utils from '../utils/utils.js'
import { getMachine } from '../graphql/queries'
import { fetchAllMachineByOffice } from '../utils/utils'
import deleteMachineconfirm from '../components/DeleteMachineConfirm'
// import VueQrcode from 'vue-qrcode'
import isFailured from "../components/failureDialog.vue"
import valiErrored from "../components/validateErrorDialog.vue"
import entSuccessed from "../components/successDialog.vue"
//import machineSuccessed from "../components/successMachineDialog.vue"
import { sortedCodesByType, } from '../graphql/queries'
import MachineLog from "../components/MachineLogDialog.vue"

function isStandardValue (value, vm) {
  if (vm.isSwStandard) {
    if (value) {
      return true
    } else {
      return false
    }
  } else {
    return true
  }
}

function analizeItemRelations() {
/*
// 追加項目は必須でないためエラーなし
  this.AnalizeItemSubError = {}
  for (var parentItem of Object.keys(this.AnalizeItemSub)) {
    if(this.AnalizeItemSub[parentItem].length==0) {
      this.AnalizeItemSubError[parentItem] = "追加する分析項目を選択してください"
      return false
    }
  }
*/
  return true
}
// (社)汚染度(計数法・SAE)Table1(PCSAE1) 関連チェック1
// (社)汚染度(計数法・SAE)Table2(PCSAE2) 関連チェック1
function analizeItemRelationPCSA1(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PCSA1M")) {
    return vm.AnalizeItems.includes("PCISOM") || vm.analizeSetItems.some(item => item.Value == "PCISOM")
  }

  if(vm.AnalizeItems.includes("PCSA2M")) {
    return vm.AnalizeItems.includes("PCISOM") || vm.analizeSetItems.some(item => item.Value == "PCISOM")
  }

  return true
}

// (社)汚染度(計数法・SAE)Table1(PCSAE1) 関連チェック2
// (社)汚染度(計数法・SAE)Table2(PCSAE2) 関連チェック2
function analizeItemRelationPCSA2(value, vm) {
  let condition1 = 0
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }

  condition1 += vm.AnalizeItems.includes("PCSA1M") ? 1 : 0
  condition1 += vm.AnalizeItems.includes("PCSA2M") ? 1 : 0
  if(condition1 >= 2) {
    return false
  }

  return true
}

// 粘度指数(VI__J) 関連チェック
function analizeItemRelationVI___J(value, vm) {
  console.log("analizeItemRelationVI___J:", vm.AnalizeItems)
  if(vm.AnalizeItems.includes("VI___J")) {
    let condition1 = 0
    condition1 += vm.AnalizeItems.includes("V40__J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V100_J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "V40__J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V100_J").length > 0 ? 1 : 0

    if(condition1 >= 2) {
      return true
    }
    return false
  }
  return true
}

// ｾﾀﾝ指数(CETINJ) 関連チェック
function analizeItemRelationCETINJ(value, vm) {
  console.log("analizeItemRelationCETINJ:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("CETINJ")) {
    let condition1 = 0
    condition1 += vm.AnalizeItems.includes("DIST_M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "DIST_M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0

    if(condition1 >= 2) {
      return true
    }
    return false
  }
  return true
}

// 総発熱量（計算値）(GCVC_J) 関連チェック
function analizeItemRelationGCVC_J(value, vm) {
  console.log("analizeItemRelationGCVC_J:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("GCVC_J")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("KF2__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4___M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("ASH__M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "KF2__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4___M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "ASH__M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    if(condition1 >= 3) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

// 真発熱量（計算値）(NCVC_J)関連チェック
function analizeItemRelationNCVC_J(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("NCVC_J")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("KF2__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4___M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("ASH__M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "KF2__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4___M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "ASH__M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    if(condition1 >= 3) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}

// 顕微鏡写真(PHO__X)関連チェック
function analizeItemRelationPHO__X(value, vm) {
  console.log("analizeItemRelationPHO__X:", vm.AnalizeItems)
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PHO__X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW01_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW10_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW45_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW80_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW12_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW50_X") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW01_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW10_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW45_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW12_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW50_X").length > 0 ? 1 : 0
    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 写真２枚(PHO2_X)関連チェック
function analizeItemRelationPHO2_X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("PHO2_X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW01_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW10_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW45_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW80_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW12_X") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("PW50_X") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW01_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW10_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW45_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW12_X").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW50_X").length > 0 ? 1 : 0
    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 酸溶解・金属元素(SOAP6X)関連チェック
function analizeItemRelationSOAP6X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("SOAP6X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0

    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 灰化・酸溶解・金属分析(SOAP5X)関連チェック
function analizeItemRelationSOAP5X(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("SOAP5X")) {
    let condition1 = 0
    
    condition1 += vm.AnalizeItems.includes("PW___M") ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "PW___M").length > 0 ? 1 : 0

    if(condition1 >= 1) {
      return true
    }
    return false
  }
  return true
}

// 環分析n-d-M法(RA___Z) 関連チェック
function analizeItemRelationRA___Z(value, vm) {
  if(this.AnalizeTypeGroup.includes("公定法")) {
    return true
  }
  if(vm.AnalizeItems.includes("RA___Z")) {
    let condition1 = 0
    let condition2 = 0
    condition1 += vm.AnalizeItems.includes("SG___J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("RID__J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V100_J") ? 1 : 0
    condition1 += vm.AnalizeItems.includes("V40__J") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S4__M") ? 1 : 0
    condition2 += vm.AnalizeItems.includes("S2___J") ? 1 : 0

    condition1 += this.analizeSetItems.filter(item => item.Value  == "SG___J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "RID__J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V100_J").length > 0 ? 1 : 0
    condition1 += this.analizeSetItems.filter(item => item.Value  == "V40__J").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S4__M").length > 0 ? 1 : 0
    condition2 += this.analizeSetItems.filter(item => item.Value  == "S2___J").length > 0 ? 1 : 0
    if(condition1 >= 4) {
      if(condition2 >= 1) {
        return true
      }
    }
    return false
  }
  return true
}



function isAnalizeSet (value, vm) {
  if (!vm.AnalizeSet&&!vm.AnalizeItems.length) {
    return false
  } else {
    return true
  }
}

function hasSystemOilUnit (value, vm) {
  if (vm.SystemOil) {
    if(!vm.SystemOilUnit) {
      return false
    }
  }
  return true
}

function hasOperatingTimeUnit (value, vm) {
  if (vm.OperatingTime) {
    if(!vm.OperatingTimeUnit) {
      return false
    }
  }
  return true
}

function hasLatestOperatingTimeUnit (value, vm) {
  if (vm.LatestOperatingTime) {
    if(!vm.LatestOperatingTimeUnit) {
      return false
    }
  }
  return true
}
function hasTotalOperatingTimeUnit (value, vm) {
  if (vm.TotalOperatingTime) {
    if(!vm.TotalOperatingTimeUnit) {
      return false
    }
  }
  return true
}
function hasSinceOverhaulTimeUnit (value, vm) {
  if (vm.SinceOverhaulTime) {
    if(!vm.SinceOverhaulTimeUnit) {
      return false
    }
  }
  return true
}
function hasNewTotalOperatingTimeUnit (value, vm) {
  if (vm.newTotalOperatingTime) {
    if(!vm.newTotalOperatingTimeUnit) {
      return false
    }
  }
  return true
}
function hasNewSinceOverhaulTimeUnit (value, vm) {
  if (vm.newSinceOverhaulTime) {
    if(!vm.newSinceOverhaulTimeUnit) {
      return false
    }
  }
  return true
}
function hasOilChangeUnit (value, vm) {
  if (vm.OilChange) {
    if(!vm.OilChangeUnit) {
      return false
    }
  }
  return true
}

function hasOilUsageTimeUnit (value, vm) {
  if (vm.OilUsageTime) {
    if(!vm.OilUsageTimeUnit) {
      return false
    }
  }
  return true
}

function hasNewOilChangeUnit (value, vm) {
  if (vm.newOilChange) {
    if(!vm.newOilChangeUnit) {
      return false
    }
  }
  return true
}

function hasNewOilUsageTimeUnit (value, vm) {
  if (vm.newOilUsageTime) {
    if(!vm.newOilUsageTimeUnit) {
      return false
    }
  }
  return true
}

function hasFilterUsageTimeUnit (value, vm) {
  if (vm.FilterUsageTime) {
    if(!vm.FilterUsageTimeUnit) {
      return false
    }
  }
  return true
}

function hasNewFilterUsageTimeUnit (value, vm) {
  if (vm.newFilterUsageTime) {
    if(!vm.newFilterUsageTimeUnit) {
      return false
    }
  }
  return true
}

function hasHazardousMaterialsDetail (value, vm) {
  if (vm.isHazardousMaterials == "1") {
    if(!vm.HazardousMaterialsDetail) {
      return false
    }
  }
  return true
}

function requiredPromptFumei (value) {
  if (!value) {
    return false
  }
  return true
}

function requiredPromptFumeiEn (value) {
  if (!value) {
    return false
  }
  return true
}

function dateFormat(value) {
  if(value) {
    if(!value.match(/^\d{4}-\d{1,2}-\d{1,2}$/)){
        return false;
    }else {
      var date = new Date(value);
      var m = value.split("-")[1];
      if(m != date.getMonth() + 1) {
        return false
      }
      return true
    }
  }
  return true
}

function requiredOilProperty(value) {
  if(this.hasOilProperties && !value) {
    return false
  }
  return true
}

function float(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1,2})?$/)){
        return false;
    }
  }
  return true
}

function useTime(value) {
  if(value) {
    let _value = String(value)
    if(!_value.match(/^([1-9]\d*|0)(\.\d{1})?$/)){
      if(_value.match(/^([0-9]\d*):([0-5][0-9])$/)){
        return true;
      }else {
        return false;
      }
    }
  }
  return true
}

function alphaNumPlus(value) {
  if(value) {
    // 半角英数（＋ハイフン、ドット、アンダースコア）のみ許可
//  if(!value.match(/^[0-9a-zA-Z/.-]*$/)){
    if(!value.match(/^[0-9a-zA-Z/.\s_-]*$/)){
        return false;
    }
  }
  return true
}

export default {

  beforeRouteLeave (to, from, next) {
    if (this.$v.$anyDirty&&!this.isPageMove) {
      let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
       next()
    }
  },

  mixins:[validations, mixin, utils ],
  components:{
    deleteMachineconfirm,
    // VueQrcode,
    sucDialog: entSuccessed,
//    msucDialog: machineSuccessed,
    appDialog: isFailured,
    valiDialog: valiErrored,
    machineLogDialog: MachineLog,
  },
  head: {
    title: { inner: 'マイ機器'},
  },
  data: () => ({
    se6: 1,
    showDescription1: false,
    showDescription2: false,
    showDescription3: false,
//    backPage: 1,
    
    samplingurl:"aa",
    Name: "",
    Type: "",
    Category: "",
    CustomerName: "",
    CustomerMachineID: "",
    MakerID: "",
    MakerText: "",
    ModelNumber: "",
    PurchasedDate: "",
    SystemOil: null,
    SystemOilUnit: "",
    SystemOilUnitText: "",
    MachineMemo: "",
    Equipment: "",

    OperatingTime: null,
    OperatingTimeUnit: "",
    OperatingTimeUnitText: "",

    TotalOperatingTime: null,
    TotalOperatingTimeUnit: "",
    TotalOperatingTimeUnitText: "",

    OverhaulDate: "",
    SinceOverhaulTime: null,
    SinceOverhaulTimeUnit: "",
    SinceOverhaulTimeUnitText: "",

    OilmakerID: "",
    OilmakerText:"",
    OilModelNumber: "",
    OilGrade: "",
    OilGradeText: "",

    isHazardousMaterials: "0",
    isAccept: "1",
    HazardousMaterialsDetail: "",

    OilChangeDate: "",
    OilChange: null,
    OilChangeUnit: "",
    OilChangeUnitText: "",

    OilUsageTime: null,
    OilUsageTimeUnit: "",
    OilUsageTimeUnitText: "",

    UseFilter: false,
    FilterUsageTime: null,
    FilterUsageTimeUnit: "",
    FilterUsageTimeUnitText: "",

    SamplingBy: "",
    SamplingPlace: "",

    AnalizeTypeCategory: "",
    AnalizeTypeGroup: "",
    AnalizeTypeGroupName: "",
    AnalizeType: "",
    AnalizeTypeName: "",
    AnalizeSet: "",
    AnalizeSetName: "",
    AnalizeItems: [],
//    AnalizeItemSub: new Map,
    AnalizeItemSub: {},
    AnalizeItemSubError: {},
    AnalizePurpose: "",
    machineTypeText: "",

    StandardValue: "0",
    StandardValueName: "0",
    Surplus: "0",
    Filter: "001",
    OfficeID: "",
    LatestOrderAt:"",
    LatestOrderNumber:"",
    LatestOperatingTime:"",
    LatestOperatingTimeUnit:"",

    OilTypeList:[],
    OilTypeCategory:"",
    OilTypeCategoryText:"",
    OilType: "",
    OilTypeText: "",

    hasOilProperties: false,
    OilPropertyList:[
      {Value:"010100", Text:"水溶性"},
      {Value:"010200", Text:"油性"},
    ],
    OilProperty:"",
    OilPropertyText:"",

    MachineCategory: "",
    MachineCategoryText: "",
    MachineType: "",
    MachineTypeText: "",

    success: false,
    dialog: false,

    e6: 1,
    machineid: "",
    machineCategory: "",
    machineType: "",

    mountedMachine: null,
    MountPosition: "",

    isCreate: true,
    isCreateMounted: false, // 機器搭載済みでマイ機器（装備品）を登録するか
    isDetailInput: false,

    // isSuccessed: false,
    isConfirmed: false,
    // isErrored: false,    
    isSelectAnalizeSet: false,
    overlayStepper1: true,
    isSwStandard: false,
    isPageMove: false,
    processing: false,
    successUrl: '/mymachinelist',
    successText: 'ご登録いただいた機器は、マイ機器よりご確認ください。',
    valiErrorText: '申請内容に不備がございます<br>赤字のエラー箇所を修正ください</p>',
    failureUrl: '/mymachinelist',

    analizeTypeGroupList: [],
    oilTypeCategoryList: [],
    machineCategoryList: [],
    machineTypeList: [],
    oilGradeList: [],

    analizeTypeList: [],
    analizeItemList: [],  // 該当分析区分の分析項目リスト
    analizeItemSubList: [],  // 該当分析区分の分析項目（サブ）リスト
    activeAnalizeItemList: [],  // 選択中のセットに含まれる項目を除いた分析リスト（依頼できる分析項目リスト）

//    analizeItemListInclude: [], // セットに含まれる分析項目リストの選択肢（≒該当区分の分析項目リスト※ないものどうしてる？）
    analizeSetItems: [], // セットに含まれる分析項目リスト
    analizeItemNames: [], // 選択中の個別分析項目の名称リスト

    analizeSetList: [],
    standardValueList: [],
    purchasedDatePicker: false,
    overhaulDatePicker: false,
    oilChangeDatePicker: false,
    latestOrderAtPicker: false,

    isErrorParam: false,
    ErrorInfo: "",
    successCreateMachine: false,

    isUsageTimeUpdate: false,
    successUsageTimeUpdate: false,
    usageTime: 0,
    syncUsageTime: true,
    newTotalOperatingTime: null,
    newTotalOperatingTimeUnit: "",
    newTotalOperatingTimeUnitText: "",
    newSinceOverhaulTime: null,
    newSinceOverhaulTimeUnit: "",
    newSinceOverhaulTimeUnitText: "",
    newOilUsageTime: null,
    newOilUsageTimeUnit: null,
    newOilUsageTimeUnitText: null,

    newOilmakerID: "",
    newOilmakerText:"",
    newOilModelNumber: "",
    newOilGrade: "",
    newOilGradeText: "",

    isOverhaulUpdate: false,
    successOverhaulUpdate: false,
    newOverhaulDate: "",
    newOverhaulDatePicker: false,
    OverhaulMemo: "",

    isOilChangeUpdate: false,
    successOilChangeUpdate: false,
    newOilChangeDate: "",
    newOilChangeDatePicker: false,
    newOilChange: null,
    newOilChangeUnit: "",
    newOilChangeUnitText: "",
    OilChangeMemo: "",

    newFilterUsageTime: null,
    newFilterUsageTimeUnit: "",
    newFilterUsageTimeUnitText: "",

    isMountMachine: false,
    isUnMountMachine: false,
    successMountMachine: false,
    successUnMountMachine: false,

    
    page: 1,
    pageCount: 0,
    totalVisible: 7,
    itemsPerPage: 10,
    itemsPerPageList: [ 5,10,30 ],
    mountMachinesHeader: [
      {
        text: '搭載中',
        align: 'start',
        value: 'mounted',
        class: "grey darken-2 white--text",
        width: '10%'
      },
      {
        text: 'マイ機器名',
        align: 'start',
        value: 'Name',
        class: "grey darken-2 white--text",
      },
      {
        text: 'マイ機器ＩＤ',
        value: 'CustomerMachineID',
        class: "grey darken-2 white--text"

      },
    ],
    mountMachines: [],
    mountMachine: null,

  }),
  validations() {
    let _validations = {
//      Name: { required, alphaNumJET, maxLength: maxLength(this.NameLen) },
//      CustomerMachineID: { alphaNumJET, maxLength: maxLength(32) },
//      Equipment: { required, alphaNumJET, maxLength: maxLength(50) },
      SystemOil: { float, hasSystemOilUnit },
      OperatingTime: { useTime, hasOperatingTimeUnit },
      LatestOperatingTime: { useTime, hasLatestOperatingTimeUnit },
      OilChange: { float, hasOilChangeUnit },
      OilUsageTime: { useTime, hasOilUsageTimeUnit },
      FilterUsageTime: { useTime, hasFilterUsageTimeUnit },
      TotalOperatingTime: { useTime, hasTotalOperatingTimeUnit },
      SinceOverhaulTime: { useTime, hasSinceOverhaulTimeUnit },
//      OilmakerID: { maxLength: maxLength(20)  },
//      OilModelNumber: { requiredPromptFumei, maxLength: maxLength(78) },
      AnalizeTypeGroup: { required },
      AnalizeType: { required },
      AnalizeSet: { isAnalizeSet,  },
      AnalizeItems: { isAnalizeSet, analizeItemRelations, analizeItemRelationPCSA1, analizeItemRelationPCSA2, analizeItemRelationVI___J, analizeItemRelationGCVC_J, analizeItemRelationNCVC_J, analizeItemRelationCETINJ, analizeItemRelationPHO__X, analizeItemRelationPHO2_X,analizeItemRelationSOAP6X,analizeItemRelationSOAP5X,analizeItemRelationRA___Z },

      AnalizeItemSub: {analizeItemRelations},
      MachineMemo: { maxLength: maxLength(256) },
//      MakerID: { maxLength: maxLength(30) },
//      ModelNumber: { maxLength: maxLength(30) },
      StandardValue: { isStandardValue },
      HazardousMaterialsDetail: { hasHazardousMaterialsDetail },
      OverhaulDate: { dateFormat },
      PurchasedDate: { dateFormat },
      LatestOrderAt: { dateFormat },
      LatestOrderNumber: { alphaNum, maxLength: maxLength(10) },
      OilTypeCategory: { required },
      OilType: { required },
      OilTypeText: { required, maxLength: maxLength(20) },
      OilProperty: { requiredOilProperty },

      usageTime: {useTime},
      newTotalOperatingTime: { useTime, hasNewTotalOperatingTimeUnit },
      newOverhaulDate: { required, dateFormat },
      newSinceOverhaulTime: { useTime, hasNewSinceOverhaulTimeUnit },
      newFilterUsageTime: { useTime, hasNewFilterUsageTimeUnit },

      newOilChangeDate: { required },
      newOilChange: { float, hasNewOilChangeUnit },
      newOilUsageTime: { useTime, hasNewOilUsageTimeUnit },
//      newOilmakerID: { requiredPromptFumei, maxLength: maxLength(20)  },
//      newOilModelNumber: { requiredPromptFumei, maxLength: maxLength(78) },
    }
    if (this.AnalizeTypeCategory == '一般') {
      _validations["Name"] = { required, maxLength: maxLength(20) }
      _validations["CustomerMachineID"] = { maxLength: maxLength(20) }
      _validations["Equipment"] = { maxLength: maxLength(20) }
      _validations["CustomerName"] = { maxLength: maxLength(50) }
      _validations["MakerID"] = { maxLength: maxLength(20) }
      _validations["ModelNumber"] = { maxLength: maxLength(20) }
      _validations["OilmakerID"] =  { maxLength: maxLength(20)  }
      _validations["OilModelNumber"] = { requiredPromptFumei, maxLength: maxLength(20) }
      _validations["newOilmakerID"] =  { maxLength: maxLength(20) }
      _validations["newOilModelNumber"] = { requiredPromptFumei, maxLength: maxLength(20) }
      _validations["SamplingBy"] = { maxLength: maxLength(12) }
      _validations["SamplingPlace"] = { maxLength: maxLength(12) }
      _validations["MountPosition"] = { numeric, maxLength: maxLength(2) }
    }else {
      _validations["Name"] = { alphaNumPlus, maxLength: maxLength(15) }
      _validations["CustomerMachineID"] = { required, alphaNumPlus, maxLength: maxLength(15) }
      _validations["Equipment"] = { alphaNumPlus, maxLength: maxLength(15) }
      _validations["CustomerName"] = { maxLength: maxLength(50) }
      _validations["MakerID"] = { alphaNumPlus, maxLength: maxLength(20) }
      _validations["ModelNumber"] = { alphaNumPlus, maxLength: maxLength(15) }
      _validations["OilmakerID"] =  { alphaNumPlus, maxLength: maxLength(20)  }
      _validations["OilModelNumber"] = { requiredPromptFumeiEn, alphaNumPlus, maxLength: maxLength(15) }
      _validations["newOilmakerID"] =  { alphaNumPlus, maxLength: maxLength(20) }
      _validations["newOilModelNumber"] = { requiredPromptFumeiEn, alphaNumPlus, maxLength: maxLength(15) }
      _validations["SamplingBy"] = { alphaNumPlus, maxLength: maxLength(12) }
      _validations["SamplingPlace"] = { alphaNumPlus, maxLength: maxLength(12) }
      _validations["MountPosition"] = { numeric, maxLength: maxLength(2) }
    }
    return _validations
  },
  computed: {
    NameErrors () {
      return this.defaultMessage(this.$v.Name)
    },
    EquipmentErrors () {
      return this.defaultMessage(this.$v.Equipment)
    },
    CustomerNameErrors () {
      return this.defaultMessage(this.$v.CustomerName)
    },
    CustomerMachineIDErrors () {
      return this.defaultMessage(this.$v.CustomerMachineID)
    },
    SystemOilErrors () {
      return this.defaultMessage(this.$v.SystemOil)
    },
    MakerIDErrors () {
      return this.defaultMessage(this.$v.MakerID)
    },
    ModelNumberErrors () {
      return this.defaultMessage(this.$v.ModelNumber)
    },
    OperatingTimeErrors () {
      return this.defaultMessage(this.$v.OperatingTime)
    },
    TotalOperatingTimeErrors () {
      return this.defaultMessage(this.$v.TotalOperatingTime)
    },
    SinceOverhaulTimeErrors () {
      return this.defaultMessage(this.$v.SinceOverhaulTime)
    },
    LatestOperatingTimeErrors () {
      return this.defaultMessage(this.$v.LatestOperatingTime)
    },
    OilChangeErrors () {
      return this.defaultMessage(this.$v.OilChange)
    },
    OilUsageTimeErrors () {
      return this.defaultMessage(this.$v.OilUsageTime)
    },
    FilterUsageTimeErrors () {
      return this.defaultMessage(this.$v.FilterUsageTime)
    },
    OilmakerIDErrors () {
      return this.defaultMessage(this.$v.OilmakerID)
    },
    OilModelNumberErrors () {
      return this.defaultMessage(this.$v.OilModelNumber)
    },
    AnalizeTypeGroupErrors () {
      return this.defaultMessage(this.$v.AnalizeTypeGroup)
    },
    AnalizeTypeErrors () {
      return this.defaultMessage(this.$v.AnalizeType)
    },
    AnalizeSetErrors () {
      return this.defaultMessage(this.$v.AnalizeSet)
    },
    AnalizeItemsErrors () {
      return this.defaultMessage(this.$v.AnalizeItems)
    },
    StandardValueErrors () {
      return this.defaultMessage(this.$v.StandardValue)
    },
    MachineMemoErrors () {
      return this.defaultMessage(this.$v.MachineMemo)
    },
    HazardousMaterialsDetailErrors () {
      return this.defaultMessage(this.$v.HazardousMaterialsDetail)
    },
    PurchasedDateErrors() {
      return this.defaultMessage(this.$v.PurchasedDate)
    },
    OverhaulDateErrors() {
      return this.defaultMessage(this.$v.OverhaulDate)
    },
    SamplingByErrors() {
      return this.defaultMessage(this.$v.SamplingBy)
    },
    SamplingPlaceErrors() {
      return this.defaultMessage(this.$v.SamplingPlace)
    },
    LatestOrderAtErrors() {
      return this.defaultMessage(this.$v.LatestOrderAt)
    },
    LatestOrderNumberErrors() {
      return this.defaultMessage(this.$v.LatestOrderNumber)
    },
    OilTypeCategoryErrors() {
      return this.defaultMessage(this.$v.OilTypeCategory)
    },
    OilTypeErrors() {
      return this.defaultMessage(this.$v.OilType)
    },
    OilTypeTextErrors() {
      return this.defaultMessage(this.$v.OilTypeText)
    },
    OilPropertyErrors() {
      return this.defaultMessage(this.$v.OilProperty)
    },
    MountPositionErrors() {
      return this.defaultMessage(this.$v.MountPosition)
    },
    newTotalOperatingTimeErrors () {
      return this.defaultMessage(this.$v.newTotalOperatingTime)
    },
    newOilUsageTimeErrors () {
      return this.defaultMessage(this.$v.newOilUsageTime)
    },
    newFilterUsageTimeErrors () {
      return this.defaultMessage(this.$v.newFilterUsageTime)
    },
    newOilChangeDateErrors () {
      return this.defaultMessage(this.$v.newOilChangeDate)
    },
    newOilChangeErrors () {
      return this.defaultMessage(this.$v.newOilChange)
    },
    newOilmakerIDErrors () {
      return this.defaultMessage(this.$v.newOilmakerID)
    },
    newOilModelNumberErrors () {
      return this.defaultMessage(this.$v.newOilModelNumber)
    },
    newOverhaulDateErrors() {
      return this.defaultMessage(this.$v.newOverhaulDate)
    },
    newSinceOverhaulTimeErrors () {
      return this.defaultMessage(this.$v.newSinceOverhaulTime)
    },
    usageTimeErrors () {
      return this.defaultMessage(this.$v.usageTime)
    },


    
    useUnits () {
      if(this.AnalizeTypeCategory != "航空機") {
        return this.$store.state.useUnits
      }else {
        // 航空機の場合はHr固定
        return this.$store.state.useUnits.filter(item => item.Value  == "10000002")
      }
    },
    liquidUnits () {
      return this.$store.state.liquidUnits
    },
    getNoticeType () {
      if (this.isHazardousMaterials == "1"){
        if(this.isAccept == "1") {
          // 危険物を含む 且つ 分析・診断サービス利用可
          return 1
        }else {
          // 危険物を含む 且つ 分析・診断サービス利用不可
          return 2
        }
      }else {
        if(this.isAccept == "1") {
          // 危険物を含まない 且つ 分析・診断サービス利用可
          return 3
        }else {
          // 危険物を含まない 且つ 分析・診断サービス利用不可
          return 4
        }
      }
    },

    isDeveloper () {
      return this.$store.state.isDeveloper
    },
    AnalizePurposeLabel() {
        let label = "主な" + this.getItemName('分析目的')[this.AnalizeTypeCategory+'label']
        return label
    },
    SamplingPlaceMessage() {
        let label = "主な" + this.getItemName('サンプル採取場所')[this.AnalizeTypeCategory+'message']
        return label
    },
    SamplingByMessage() {
        let label = "主な" + this.getItemName('採取者')[this.AnalizeTypeCategory+'message']
        return label
    },
  },
  methods: {

      back: async function() {
          this.$router.back()
      },
      copyMachine: async function () {
        if (this.$v.$anyDirty&&!this.isPageMove) {
          let answer = window.confirm("編集中のデータがあります。本当にこのページから離れますか？")
          if (!answer) {
            return
          }
        }
        this.isCreate = true
        this.getMachine()
        this.machineid = ""
      },
      showAircraft: function() {
        this.$router.push("myaircraft?id=" + this.mountedMachine.id)
      },
      showDetailInput: function () {
        this.isDetailInput = true
        this.e6 = 1
        this.moveToTop()
      },
      closeDetailInput: async function() {
        this.isDetailInput = false
        this.isPageMove=true
        await this.getMachine()

        // 航空機の場合、使用時間系の単位はHr固定
        if(this.AnalizeTypeCategory == "航空機") {
          this.TotalOperatingTimeUnit = "10000002"
          this.TotalOperatingTimeUnitText = ""
          this.SinceOverhaulTimeUnit = "10000002"
          this.SinceOverhaulTimeUnitText = ""
          this.FilterUsageTimeUnit = "10000002"
          this.FilterUsageTimeUnitText = ""
          this.OilUsageTimeUnit = "10000002"
          this.OilUsageTimeUnitText = ""
        }

        this.moveToTop()
      },
      showMountMachine: async function() {
        let OfficeID = this.$store.state.operatingOffice.OfficeID
        let typeFilter = {
          Type:{
            contains: "機体"
          },
        }
        let machines = await fetchAllMachineByOffice(OfficeID, typeFilter)
        this.mountMachines = machines;

        this.se6 = 1
        this.MountPosition = ""
        this.isMountMachine = true
      },
      showUnMountMachine: async function() {
        this.isUnMountMachine = true
      },
      selectMountMachine: async function(data) {
        this.mountMachine = data
        console.log("selectMountMachine", this.mountMachine)
        this.se6 = 2
      },
      updateMountMachine: async function() {
        try {
          console.log("mount Machine:", this.mountMachine)

          this.$v.MountPosition.$touch()
          if (this.$v.MountPosition.$invalid){
            console.log('updateMountMachine input error')
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            return 1
          }

          let machine = {}
          machine["id"] = this.machineid
          machine["MountedMachineID"] = this.mountMachine.id
          machine["MountPosition"] = this.MountPosition
          await API.graphql(graphqlOperation(updateMachine, {input: machine}))

          let machineLog = {}
          machineLog.MachineID = this.machineid
          machineLog.Type = "Mount"
          machineLog.Detail = this.mountMachine.Name + "/" + this.MountPosition
          await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

          this.mountedMachine = this.mountMachine

          this.mountMachine = null
          this.isMountMachine = false
          this.successMountMachine = true
        } catch (error) {
          console.log('error: ', error)
          this.processing = false
          this.$refs.isFailured.open();
        }
      },
      UnmountMachine: async function() {
        try {
          console.log("unmount Machine:", this.mountedMachine)
          let machine = {}
          machine["id"] = this.machineid
          machine["MountedMachineID"] = null
          machine["MountPosition"] = ""
          await API.graphql(graphqlOperation(updateMachine, {input: machine}))

          let machineLog = {}
          machineLog.MachineID = this.machineid
          machineLog.Type = "Unmount"
          machineLog.Detail = this.mountedMachine.Name
          await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

          this.mountedMachine = null
          this.mountMachine = null
          this.isUnMountMachine = false
          this.successUnMountMachine = true
        } catch (error) {
          console.log('UnmountMachine error: ', error)
          this.processing = false
          this.$refs.isFailured.open();
        }
      },
      showUpdateOilChange: async function() {
        this.newOilmakerID =this.OilmakerID
        this.newOilmakerText =this.OilmakerText
        this.newOilModelNumber =this.OilModelNumber
        this.newOilGrade =this.OilGrade
        this.newOilGradeText = this.OilGradeText

        this.newOilChangeDate = ""
        this.newOilChange = ""
        this.newOilChangeUnit = this.OilChangeUnit
        this.newOilChangeUnitText = this.OilChangeUnitText

        this.newOilUsageTime = ""
        this.newOilUsageTimeUnit = this.OilUsageTimeUnit
        this.newOilUsageTimeUnitText = this.OilUsageTimeUnitText

        // 航空機の場合、使用時間系の単位はHr固定
        if(this.AnalizeTypeCategory == "航空機") {
          this.newOilUsageTimeUnit = "10000002"
          this.newOilUsageTimeUnitText = ""
        }else {
          this.newOilUsageTimeUnit = ""
          this.newOilUsageTimeUnitText = ""
        }

        this.isOilChangeUpdate = true
      },
      closeUpdateOilChange: async function() {
        this.isPageMove=true
        this.isOilChangeUpdate = false
      },

      updateOverhaulDate: async function() {
        this.$v.newOverhaulDate.$touch()
        this.$v.newSinceOverhaulTime.$touch()
        if ((this.$v.newOverhaulDate.$invalid) ||
            (this.$v.newSinceOverhaulTime.$invalid)
        ){
          console.log('updateOverhaulDate input error')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }
        try {
          let machine = {}
          machine["id"] = this.machineid
          machine["OverhaulDate"] = this.newOverhaulDate
          machine["SinceOverhaulTime"] = this.newSinceOverhaulTime
          machine["SinceOverhaulTimeUnit"] = this.newSinceOverhaulTimeUnit
          machine["SinceOverhaulTimeUnitText"] = this.newSinceOverhaulTimeUnitText
          
          await API.graphql(graphqlOperation(updateMachine, {input: machine}))

          let machineLog = {}
          machineLog.MachineID = this.machineid
          machineLog.Type = "Overhaul"
          machineLog.Detail = this.newOverhaulDate + "/" +
                              this.newSinceOverhaulTime + " " + this.newSinceOverhaulTimeUnitText
          machineLog.Description = this.OverhaulMemo
          await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

          this.OverhaulDate = this.newOverhaulDate
          this.SinceOverhaulTime = this.newSinceOverhaulTime
          this.SinceOverhaulTimeUnit = this.newSinceOverhaulTimeUnit
          this.SinceOverhaulTimeUnitText = this.newSinceOverhaulTimeUnitText

          this.isOverhaulUpdate = false
          this.successOverhaulUpdate = true
        } catch (error) {
          console.log('updateOverhaulDate error: ', error)
          this.processing = false
          this.$refs.isFailured.open();
        }

      },
      updateOilChange: async function() {
        this.$v.newOilChangeDate.$touch()
        this.$v.newOilmakerID.$touch()
        this.$v.newOilModelNumber.$touch()
        this.$v.newOilChange.$touch()
        this.$v.newOilUsageTime.$touch()
        if ((this.$v.newOilChangeDate.$invalid) ||
            (this.$v.newOilmakerID.$invalid) ||
            (this.$v.newOilModelNumber.$invalid) ||
            (this.$v.newOilChange.$invalid) ||
            (this.$v.newOilUsageTime.$invalid)
        ){
          console.log('updateOilChange input error')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }

        try {
          // float型の項目は未入力の場合はnull置き換え
          if(this.newOilChange == "") {
            this.newOilChange = null
            this.newOilChangeUnit = ""
            this.newOilChangeUnitText = ""
          }
          if(this.newOilUsageTime == "") {
            this.newOilUsageTime = null
            this.newOilUsageTimeUnit = ""
            this.newOilUsageTimeUnitText = ""
          }

          let machine = {}
          machine["id"] = this.machineid
          machine["OilChangeDate"] = this.newOilChangeDate
          machine["OilmakerID"] = this.newOilmakerID
          machine["OilmakerText"] = this.newOilmakerID
          machine["OilModelNumber"] = this.newOilModelNumber
          machine["OilGrade"] = this.newOilGrade
          machine["OilGradeText"] = this.newOilGradeText
          machine["OilChange"] = this.newOilChange
          machine["OilChangeUnit"] = this.newOilChangeUnit
          machine["OilChangeUnitText"] = this.newOilChangeUnitText
          machine["OilUsageTime"] = this.newOilUsageTime
          machine["OilUsageTimeUnit"] = this.newOilUsageTimeUnit
          machine["OilUsageTimeUnitText"] = this.newOilUsageTimeUnitText
          await API.graphql(graphqlOperation(updateMachine, {input: machine}))

          let machineLog = {}
          machineLog.MachineID = this.machineid
          machineLog.Type = "OilChange"
          machineLog.Detail = this.newOilChangeDate + "/" +
                              this.newOilmakerID + " " + this.newOilModelNumber + " " + this.newOilGradeText +
                              "[OIL ADDED]" + this.newOilChange + " " + this.newOilChangeUnitText +
                              "[TSOD]" + this.newOilUsageTime + " " + this.newOilUsageTimeUnitText

          machineLog.Description = this.OilChangeMemo
          await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

          this.OilmakerID =this.newOilmakerID
          this.OilmakerText =this.newOilmakerText
          this.OilModelNumber =this.newOilModelNumber
          this.OilGrade =this.newOilGrade
          this.OilGradeText = this.newOilGradeText

          this.OilChangeDate = this.newOilChangeDate
          this.OilChange = this.newOilChange
          this.OilChangeUnit = this.newOilChangeUnit
          this.OilChangeUnitText = this.newOilChangeUnitText

          this.OilUsageTime = this.newOilUsageTime
          this.OilUsageTimeUnit = this.newOilUsageTimeUnit
          this.OilUsageTimeUnitText = this.newOilUsageTimeUnitText

          this.isOilChangeUpdate = false
          this.successOilChangeUpdate = true
        } catch (error) {
          console.log('updateOilChange error: ', error)
          this.processing = false
          this.$refs.isFailured.open();
        }
      },
      showUpdateOverhaul: async function() {
        this.newOverhaulDate = ""
        this.newSinceOverhaulTime = null
        // 航空機の場合、使用時間系の単位はHr固定
        if(this.AnalizeTypeCategory == "航空機") {
          this.newSinceOverhaulTimeUnit = "10000002"
          this.newSinceOverhaulTimeUnitText = ""
        }else {
          this.newSinceOverhaulTimeUnit = ""
          this.newSinceOverhaulTimeUnitText = ""
        }

        this.isOverhaulUpdate = true
      },
      closeUpdateOverhaul: async function() {
        this.isPageMove=true
        this.isOverhaulUpdate = false
      },

      showUpdateUsageTime: async function() {
//        this.calcUsageTime()

        this.usageTime = 0
        this.syncUsageTime = false

        this.newTotalOperatingTime = this.TotalOperatingTime
        this.newTotalOperatingTimeUnit = this.TotalOperatingTimeUnit
        this.newTotalOperatingTimeUnitText = this.TotalOperatingTimeUnitText

        this.newOilUsageTime = this.OilUsageTime
        this.newOilUsageTimeUnit = this.OilUsageTimeUnit
        this.newOilUsageTimeUnitText = this.OilUsageTimeUnitText

        this.newSinceOverhaulTime = this.SinceOverhaulTime
        this.newSinceOverhaulTimeUnit = this.SinceOverhaulTimeUnit
        this.newSinceOverhaulTimeUnitText = this.SinceOverhaulTimeUnitText

        this.newFilterUsageTime = this.FilterUsageTime
        this.newFilterUsageTimeUnit = this.FilterUsageTimeUnit
        this.newFilterUsageTimeUnitText = this.FilterUsageTimeUnitText

        // 航空機の場合、使用時間系の単位はHr固定
        if(this.AnalizeTypeCategory == "航空機") {
          this.newTotalOperatingTimeUnit = "10000002"
          this.newTotalOperatingTimeUnitText = ""
          this.newSinceOverhaulTimeUnit = "10000002"
          this.newSinceOverhaulTimeUnitText = ""
          this.newFilterUsageTimeUnit = "10000002"
          this.newFilterUsageTimeUnitText = ""
          this.newOilUsageTimeUnit = "10000002"
          this.newOilUsageTimeUnitText = ""
        }
        this.isUsageTimeUpdate = true
      },
      changeSyncUsageTime: async function() {
        // $nextTickを使用してv-modelの値更新を待つ
//        await this.$nextTick()
        if(this.syncUsageTime) {
          this.calcUsageTime()
        }else {
          this.newTotalOperatingTime = this.TotalOperatingTime
          this.newOilUsageTime = this.OilUsageTime
          this.newSinceOverhaulTime = this.SinceOverhaulTime
          this.newFilterUsageTime = this.FilterUsageTime
        }
      },
      calcUsageTime: async function() {
        await this.$nextTick()
        if (!this.$v.usageTime.$invalid) {        
          console.log("calcUsageTime syncUsageTime:", this.syncUsageTime)
          console.log("calcUsageTime usageTime:", this.usageTime)
          console.log("calcUsageTime newTotalOperatingTime:", this.newTotalOperatingTime)
          if(this.syncUsageTime) {

            if(this.newTotalOperatingTime != null) {
              this.newTotalOperatingTime = this.calcTime(this.TotalOperatingTime, this.usageTime)
            }
            if(this.newOilUsageTime != null) {
              this.newOilUsageTime = this.calcTime(this.OilUsageTime, this.usageTime)
            }

            // 航空機の場合 オーバーホールしていない＝オーバーホール日が設定されていない場合は更新しない
            if(this.OverhaulDate) {
              this.newSinceOverhaulTime = this.calcTime(this.SinceOverhaulTime, this.usageTime)
            }

            // 航空機の場合 フィルター使用時間を管理している場合は更新
            console.log("calcUsageTime UseFilter:", this.UseFilter)
            if(this.UseFilter) {
              this.newFilterUsageTime = this.calcTime(this.FilterUsageTime, this.usageTime)
            }
          }
        }
      },
      updateUsageTime: async function() {
        this.$v.newTotalOperatingTime.$touch()
        this.$v.newOilUsageTime.$touch()
        this.$v.newSinceOverhaulTime.$touch()
        this.$v.newFilterUsageTime.$touch()

        if ((this.$v.newTotalOperatingTime.$invalid) ||
            (this.$v.newOilUsageTime.$invalid) ||
            (this.$v.newSinceOverhaulTime.$invalid) ||
            (this.$v.newFilterUsageTime.$invalid)
        ){
          console.log('updateUsageTime input error')
          this.$refs.isErrored.open();
          this.isErrored = true
          this.processing = false
          return 1
        }

        try {
          // float型の項目は未入力の場合はnull置き換え
          if(this.newTotalOperatingTime == "") {
            this.newTotalOperatingTime = null
            this.newTotalOperatingTimeUnit = ""
            this.newTotalOperatingTimeUnitText = ""
          }

          if(this.newOilUsageTime == "") {
            this.newOilUsageTime = null
            this.newOilUsageTimeUnit = ""
            this.newOilUsageTimeUnitText = ""
          }

          if(this.newSinceOverhaulTime == "") {
            this.newSinceOverhaulTime = null
            this.newSinceOverhaulTimeUnit = ""
            this.newSinceOverhaulTimeUnitText = ""
          }

          if(this.newFilterUsageTime == "") {
            this.newFilterUsageTimeTime = null
            this.newFilterUsageTimeUnit = ""
            this.newFilterUsageTimeUnitText = ""
          }

          let machine = {}
          machine["id"] = this.machineid
          machine["TotalOperatingTime"] = this.newTotalOperatingTime
          machine["TotalOperatingTimeUnit"] = this.newTotalOperatingTimeUnit
          machine["TotalOperatingTimeUnitText"] = this.newTotalOperatingTimeUnitText

          machine["OilUsageTime"] = this.newOilUsageTime
          machine["OilUsageTimeUnit"] = this.newOilUsageTimeUnit
          machine["OilUsageTimeUnitText"] = this.newOilUsageTimeUnitText

          machine["SinceOverhaulTime"] = this.newSinceOverhaulTime
          machine["SinceOverhaulTimeUnit"] = this.newSinceOverhaulTimeUnit
          machine["SinceOverhaulTimeUnitText"] = this.newSinceOverhaulTimeUnitText

          machine["FilterUsageTime"] = this.newFilterUsageTime
          machine["FilterUsageTimeUnit"] = this.newFilterUsageTimeUnit
          machine["FilterUsageTimeUnitText"] = this.newFilterUsageTimeUnitText

          await API.graphql(graphqlOperation(updateMachine, {input: machine}))

          let machineLog = {}
          machineLog.MachineID = this.machineid
          machineLog.Type = "UsageTime"
          machineLog.Detail = "[T.T]" + this.newTotalOperatingTime + " " + this.newTotalOperatingTimeUnitText + " " +
                              "[TSOD]" + this.newOilUsageTime + " " + this.newOilUsageTimeUnitText + " " +
                              "[TSO]" + this.newSinceOverhaulTime + " " + this.newSinceOverhaulTimeUnitText + " " +
                              "[TSOF]" + this.newFilterUsageTime + " " + this.newFilterUsageTimeUnitText

          await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))


          this.TotalOperatingTime = this.newTotalOperatingTime
          this.TotalOperatingTimeUnit = this.newTotalOperatingTimeUnit
          this.TotalOperatingTimeUnitText = this.newTotalOperatingTimeUnitText 

          this.OilUsageTime = this.newOilUsageTime
          this.OilUsageTimeUnit = this.newOilUsageTimeUnit
          this.OilUsageTimeUnitText = this.newOilUsageTimeUnitText

          this.SinceOverhaulTime = this.newSinceOverhaulTime
          this.SinceOverhaulTimeUnit = this.newSinceOverhaulTimeUnit
          this.SinceOverhaulTimeUnitText = this.newSinceOverhaulTimeUnitText

          this.FilterUsageTime = this.newFilterUsageTime
          this.FilterUsageTimeUnit = this.newFilterUsageTimeUnit
          this.FilterUsageTimeUnitText = this.newFilterUsageTimeUnitText

          this.usageTime = 0

          this.newTotalOperatingTime = null
          this.newTotalOperatingTimeUnit = ""
          this.newTotalOperatingTimeUnitText = ""

          this.newOilUsageTime = null
          this.newOilUsageTimeUnit = ""
          this.newOilUsageTimeUnitText = ""

          this.newSinceOverhaulTime = null
          this.newSinceOverhaulTimeUnit = ""
          this.newSinceOverhaulTimeUnitText = ""

          this.newFilterUsageTime = null
          this.newFilterUsageTimeUnit = ""
          this.newFilterUsageTimeUnitText = ""

          this.isUsageTimeUpdate = false
          this.successUsageTimeUpdate = true

          this.isPageMove=true
        } catch (error) {
          console.log('updateUsageTime error: ', error)
          this.isPageMove=true
          this.processing = false
          this.$refs.isFailured.open();
        }
      },
      changeStepper: function(step) {
        let next = this.validation(step) 
        this.e6 = next
      },
      validation: function (step) {
        if(step >= 2) {
          this.$v.Name.$touch()
          this.$v.CustomerMachineID.$touch()
          this.$v.Equipment.$touch()
          this.$v.CustomerName.$touch()
          this.$v.MakerID.$touch()
          this.$v.ModelNumber.$touch()
//          this.$v.MachineCategory.$touch()
//          this.$v.MachineType.$touch()
          this.$v.PurchasedDate.$touch()
          this.$v.TotalOperatingTime.$touch()
          this.$v.OverhaulDate.$touch()
          this.$v.SinceOverhaulTime.$touch()
          this.$v.SystemOil.$touch()
          this.$v.LatestOrderAt.$touch()
          this.$v.LatestOrderNumber.$touch()
          if (this.$v.Name.$invalid ||
              this.$v.CustomerMachineID.$invalid ||
              this.$v.Equipment.$invalid ||
              this.$v.CustomerName.$invalid ||
              this.$v.MakerID.$invalid ||
              this.$v.ModelNumber.$invalid ||
//              this.$v.MachineCategory.$invalid ||
//              this.$v.MachineType.$invalid ||
              this.$v.PurchasedDate.$invalid ||
              this.$v.TotalOperatingTime.$invalid ||
              this.$v.OverhaulDate.$invalid ||
              this.$v.SinceOverhaulTime.$invalid ||
              this.$v.SystemOil.$invalid ||
              this.$v.LatestOrderAt.$invalid ||
              this.$v.LatestOrderNumber.$invalid
          ) {
            console.log('error: ', 'validation error Page1')
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            return 1
          }
        }
        if(step >= 3) {
          this.$v.OilTypeCategory.$touch()
          this.$v.OilType.$touch()
          this.$v.OilProperty.$touch()
          this.$v.OilmakerID.$touch()
          this.$v.OilModelNumber.$touch()
//          this.$v.OilGrade.$touch()
//          this.$v.LatestOrderAt.$touch()
//          this.$v.LatestOrderNumber.$touch()
//          this.$v.OilChangeDate.$touch()
          this.$v.OilChange.$touch()
          this.$v.OilUsageTime.$touch()
//          this.$v.SamplingPlace.$touch()
          this.$v.HazardousMaterialsDetail.$touch()
          if (this.$v.OilTypeCategory.$invalid ||
              this.$v.OilType.$invalid ||
              this.$v.OilProperty.$invalid ||
              this.$v.OilmakerID.$invalid ||
              this.$v.OilModelNumber.$invalid ||
//              this.$v.OilGrade.$invalid ||
//              this.$v.LatestOrderAt.$invalid ||
//              this.$v.LatestOrderNumber.$invalid ||
//              this.$v.OilChangeDate.$invalid ||
              this.$v.OilChange.$invalid ||
              this.$v.OilUsageTime.$invalid ||
//              this.$v.SamplingPlace.$invalid
              this.$v.HazardousMaterialsDetail.$invalid
          ) {
            console.log('error: ', 'validation error Page2')
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            return 2
          }
        }
        if(step >= 4) {
          this.$v.AnalizeTypeGroup.$touch()
          this.$v.AnalizeType.$touch()
          this.$v.StandardValue.$touch()
          this.$v.AnalizeSet.$touch()
          this.$v.AnalizeItems.$touch()
          if (this.$v.AnalizeTypeGroup.$invalid ||
              this.$v.AnalizeType.$invalid ||
              this.$v.StandardValue.$invalid ||
              this.$v.AnalizeItems.$invalid ||
              this.$v.AnalizeSet.$invalid
          ){
            console.log('error: ', 'validation error Page3')
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            return 3
          }
        }

        return step
      },

      confirmCreateMachine: async function() {
        let val = this.validation(4)
        if(val == 4) {
          this.isConfirmed=true
        }
      },

      createMachine: async function () {
        this.isConfirmed = false
        this.processing = true
/*
        let val = this.validation(4)
        if(val != 4) {
          return
        }
*/

/*
        this.$v.$touch()
        if (this.$v.$invalid) {
          //1 マイ機器情報 のエリアで入力エラーがあった場合
          if (this.$v.Name.$invalid ||
              this.$v.CustomerMachineID.$invalid ||
              this.$v.SystemOil.$invalid ||
              this.$v.OperatingTime.$invalid ||
              this.$v.PurchasedDate.$invalid ||
              this.$v.TotalOperatingTime.$invalid
            ) {
            console.log('error: ', 'validation error Page1')
            this.$refs.isErrored.open();
            this.isErrored = true
            this.e6 = 1
            this.processing = false
            return
          // 使用オイル のエリアで入力エラーがあった場合
          } else if (this.$v.OilmakerID.$invalid ||
                     this.$v.OilModelNumber.$invalid ||
                     this.$v.OilChange.$invalid ||
                     this.$v.OilChange.$invalid ||
                     this.$v.OilUsageTime.$invalid ||
                     this.$v.LatestOrderAt.$invalid ||
                     this.$v.HazardousMaterialsDetail.$invalid){
            console.log('error: ', 'validation error Page2')
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            this.e6 = 2
            return
          // 分析項目 のエリアで入力エラーがあった場合
          } else if (this.$v.AnalizeTypeGroup.$invalid ||
                     this.$v.AnalizeType.$invalid ||
                     this.$v.StandardValue.$invalid ||
                     this.$v.AnalizeItems.$invalid ||
                     this.$v.AnalizeSet.$invalid){
            console.log('error: ', 'validation error Page3')
            this.$refs.isErrored.open();
            this.isErrored = true
            this.processing = false
            this.e6 = 3
            return
          }
        } 
*/

        if(this.isHazardousMaterials == "0") {
          this.HazardousMaterialsDetail = ""
        }
        // fload型の要素はnullに変換
        if(this.TotalOperatingTime == "") this.TotalOperatingTime = null
        if(this.SystemOil == "") this.SystemOil = null
        if(this.OperatingTime == "") this.OperatingTime = null
        if(this.OilChange == "") this.OilChange = null
        if(this.OilUsageTime == "") this.OilUsageTime = null
        if(this.LatestOperatingTime == "") this.LatestOperatingTime = null


        let _LatestOrderAt = ""
        if(this.LatestOrderAt == null) {
          this.LatestOrderAt = ""
        }        
        if(this.LatestOrderAt != "") {
          let _date = new Date(this.LatestOrderAt)
          let format_str = 'YYYY-MM-DD';
          format_str = format_str.replace(/YYYY/g, _date.getFullYear());
          format_str = format_str.replace(/MM/g, _date.getMonth() + 1);
          format_str = format_str.replace(/DD/g, _date.getDate());
          _LatestOrderAt = format_str
        }

        let _PurchasedDate = ""
        if(this.PurchasedDate == null) {
          this.PurchasedDate = ""
        }
        if(this.PurchasedDate != "") {
          let _date = new Date(this.PurchasedDate)
          let format_str = 'YYYY-MM-DD';
          format_str = format_str.replace(/YYYY/g, _date.getFullYear());
          format_str = format_str.replace(/MM/g, ('0' + (_date.getMonth() + 1)).slice(-2));
          format_str = format_str.replace(/DD/g, ('0' + _date.getDate()).slice(-2));
          _PurchasedDate = format_str
        }

        // 航空機の場合、使用時間系の単位はHr固定（データは空白）
        if(this.AnalizeTypeCategory == "航空機") {
          this.TotalOperatingTimeUnit = "10000002"
          this.TotalOperatingTimeUnitText = ""
          this.SinceOverhaulTimeUnit = "10000002"
          this.SinceOverhaulTimeUnitText = ""
          this.FilterUsageTimeUnit = "10000002"
          this.FilterUsageTimeUnitText = ""
          this.OilUsageTimeUnit = "10000002"
          this.OilUsageTimeUnitText = ""
        }

        const machine = {
          Name: this.Name,
          Type: this.Type,
          CustomerName: this.CustomerName,
          CustomerMachineID: this.CustomerMachineID,
          Equipment: this.Equipment,
          MakerID: this.MakerID,
          MakerText: this.MakerID,
          ModelNumber: this.ModelNumber,
//          PurchasedDate: this.PurchasedDate,
          PurchasedDate: _PurchasedDate,
          SystemOil: this.SystemOil,
          SystemOilUnit: this.SystemOilUnit,
          SystemOilUnitText: this.SystemOilUnitText,
          MachineMemo: this.MachineMemo,
          TotalOperatingTime: this.TotalOperatingTime,
          TotalOperatingTimeUnit: this.TotalOperatingTimeUnit,
          TotalOperatingTimeUnitText: this.TotalOperatingTimeUnitText,
          OperatingTime: this.OperatingTime,
          OperatingTimeUnit: this.OperatingTimeUnit,
          OperatingTimeUnitText: this.OperatingTimeUnitText,
          OverhaulDate: this.OverhaulDate,
          SinceOverhaulTime: this.SinceOverhaulTime,
          SinceOverhaulTimeUnit: this.SinceOverhaulTimeUnit,
          SinceOverhaulTimeUnitText: this.SinceOverhaulTimeUnitText,
          OilmakerID: this.OilmakerID,
          OilModelNumber: this.OilModelNumber,
          OilTypeCategory: this.OilTypeCategory,
          OilTypeCategoryText: this.OilTypeCategoryText,
          OilType: this.OilType,
          OilTypeText: this.OilTypeText,
          OilProperty: this.OilProperty,
          OilPropertyText: this.OilPropertyText,
          isHazardousMaterials: this.isHazardousMaterials,
          HazardousMaterialsDetail: this.HazardousMaterialsDetail,
          OilChangeDate: this.OilChangeDate,
          OilChange: this.OilChange,
          OilChangeUnit: this.OilChangeUnit,
          OilChangeUnitText: this.OilChangeUnitText,
          UseFilter: this.UseFilter,
          FilterUsageTime: this.FilterUsageTime,
          FilterUsageTimeUnit: this.FilterUsageTimeUnit,
          FilterUsageTimeUnitText: this.FilterUsageTimeUnitText,
          OilUsageTime: this.OilUsageTime,
          OilUsageTimeUnit: this.OilUsageTimeUnit,
          OilUsageTimeUnitText: this.OilUsageTimeUnitText,
          SamplingBy: this.SamplingBy,
          SamplingPlace: this.SamplingPlace,
          AnalizeTypeGroup: this.AnalizeTypeGroup,                    
          AnalizeType: this.AnalizeType,
          AnalizeSet: this.AnalizeSet,
          AnalizeItems: JSON.stringify(this.AnalizeItems),
          AnalizeItemSub: JSON.stringify(this.AnalizeItemSub),
          AnalizePurpose: this.AnalizePurpose,
          StandardValue: this.StandardValue,
          Surplus: this.Surplus,
          Filter: this.Filter,
          OfficeID: this.$store.state.operatingOffice.OfficeID,
          isAccept: this.isAccept,
          LatestOrderNumber: this.LatestOrderNumber,
          LatestOrderAt: _LatestOrderAt,
//          LatestOrderAt: this.LatestOrderAt,
          LatestOperatingTime: this.LatestOperatingTime,
          LatestOperatingTimeUnit: this.LatestOperatingTimeUnit,
          LatestOperatingTimeUnitText: this.LatestOperatingTimeUnitText,
          MountPosition: this.MountPosition
        }
        
        // 搭載機指定で新規登録の場合は機体IDを設定
        if(this.isCreateMounted) {
          machine["MountedMachineID"] = this.mountedMachine.id
        }

        console.log("update or create machine:", machine)
        try {
          if(this.isCreate) {
            let result = await API.graphql(graphqlOperation(createMachine, {input: machine}))
            console.log('success', result)
            this.successText = '新しいマイ機器を登録しました。<br><br>ご登録いただいた機器は、マイ機器よりご確認ください。',
            window.removeEventListener("beforeunload", this.handler)
            this.isPageMove=true
            this.machineid = result.data.createMachine.id
            this.isConfirmed = false
            this.successCreateMachine = true
//            this.$refs.isMSuccessed.open(result);
            // this.$router.push('/mymachinelist')
          }else {
            machine["id"] = this.machineid
            await API.graphql(graphqlOperation(updateMachine, {input: machine}))

            let machineLog = {}
            machineLog.MachineID = this.machineid
            machineLog.Type = "Update"
            machineLog.Detail = JSON.stringify(machine)

            await API.graphql(graphqlOperation(createMachineLog, {input: machineLog}))

            this.successText = 'マイ機器情報を更新しました。<br><br>更新した内容は、マイ機器一覧よりご確認ください。',
            window.removeEventListener("beforeunload", this.handler)
            this.isPageMove=true
            this.isConfirmed = false
            this.successCreateMachine = true
//            this.$refs.isSuccessed.open();
          }
        } catch (error) {
          console.log('error: ', error)
          this.processing = false
          this.$refs.isFailured.open();
        }
      },

      deleteMachine: async function () {
          const deleteinfo = {
            id: this.machineid,
          }
          try {
            await API.graphql(graphqlOperation(deleteMachine, {input: deleteinfo}))
            window.removeEventListener("beforeunload", this.handler)
            this.isPageMove=true
            this.$router.push('/mymachinelist')
          } catch (error) {
            console.log('error: ', error)
          }
      },
      showDialog() {
        this.$refs.deletedialog.open();
      },

      changeAnalizeTypeGroup: async function() {
          this.isSelectAnalizeSet = false
          const typeGroup = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
          this.analizeTypeList = await this.getAnalizeTypeList(this.AnalizeTypeGroup)
          this.AnalizeTypeGroupName = typeGroup[0].Text

          if(this.OilTypeCategory){
            this.AnalizeType = String(Number(typeGroup[0].Code) + Number(this.OilTypeCategory))
            this.changeAnalizeType()
          }
      },
      changeAnalizeType: async function () {
          this.isSelectAnalizeSet = false
          this.analizeSetList = await this.getAnalizeSetList(this.AnalizeType)
          this.analizeItemList = await this.getAnalizeItemList(this.AnalizeType)
          this.activeAnalizeItemList = this.analizeItemList
          this.analizeItemSubList = await this.getAnalizeItemSubList(this.AnalizeType)
/* 一旦削除！
          let standardvaluelist = this.$store.state.standardValueList.filter(item => item.AnalizeType  == this.AnalizeType)
          this.standardValueList = standardvaluelist[0].standardValues
*/

          this.AnalizeSet = ""
          this.AnalizeSetName = ""
          this.AnalizeItems = ""
//          this.AnalizeItemSub = new Map
          this.AnalizeItemSub = {}
          this.StandardValue = ""
          this.StandardValueName = ""
          this.isSwStandard = false

          const AnalizeTypeName = this.analizeTypeList.filter(item => item.Value  == this.AnalizeType)
          this.AnalizeTypeName = AnalizeTypeName[0].Text
      },
      changeAnalizeSet: async function () {
          this.isSelectAnalizeSet = false
          if (this.AnalizeSet) {
            // セットが選びなおされた場合、個別分析項目をリセットする（セットと重複することがあるため）
            this.AnalizeItems = []
            this.AnalizeItemSub = {}

            const analizeSet = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
            this.AnalizeSetName = analizeSet[0].Text
            this.analizeSetItems = []
//            this.includeItem()
            this.activeAnalizeItemList = await this.excludeAnalizeItems(analizeSet[0].AnalizeItems, this.analizeItemList)

            this.analizeSetItems = await this.getAnalizeSetItems(analizeSet[0])
            this.isSelectAnalizeSet = true

          } else {
            this.activeAnalizeItemList = this.analizeItemList
            this.AnalizeSet = ""
            this.AnalizeSetName = ""
            this.analizeSetItems = []
          }
          await this.changeAnalizeItems(this.AnalizeItems)
          // セット分析の選択・解除に伴い、個別分析項目のバリデーションを再評価させる
          // （初期表示直後はまだ未touchのため、セットを✕で消してもチェックが動かない対策）
          this.$v.AnalizeItems.$touch()
      },
      changeAnalizeItems: async function(selecteditems) {
        for (var parentItem of Object.keys(this.analizeItemSubList)) {
          if(selecteditems.includes(parentItem)) {
            // サブ項目がある分析項目がえらばれている場合は配列をセット（継続）
            let selectedSub = this.AnalizeItemSub[parentItem]
            if(selectedSub == undefined) {
              selectedSub = []
            }

            // 注：vueの再描画（DOMの再評価）がされない（謎）
            // vueに変更を検知させるために$setを使う
//            this.AnalizeItemSub[parentItem] = selectedSub
            this.$set(this.AnalizeItemSub, parentItem, selectedSub);
          }else {
            const includeSet = this.analizeSetItems.filter(item => item.Value  == parentItem)
            if(!includeSet[0]) {
              // サブ項目がある分析項目が選ばれていなかった且つ、セットにも含まれていない場合は削除（リセット）
              delete this.AnalizeItemSub[parentItem]
            }else {
              let selectedSub = this.AnalizeItemSub[parentItem]
              if(selectedSub == undefined) {
                selectedSub = []
              }
              this.$set(this.AnalizeItemSub, parentItem, selectedSub);
            }
          }
        }

        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
        console.log("analizeItemNames:", this.analizeItemNames)

      },
      changeAnalizeItemSub: async function() {
        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
        console.log("analizeItemNames:", this.analizeItemNames)
        
        // 強制的に個別分析項目のvalidationを実行させるために値を一次的に変更
        //値が変わらないとtouchが実行されない=validationsが実行されない        
        this.AnalizeItems.push("dummy")
        this.AnalizeItems.pop("dummy")
        this.$v.AnalizeItems.$touch()
      },
      changeStandardValue: async function () {
          const StandardValueName = this.standardValueList.filter(item => item.Value  == this.StandardValue)
          if (StandardValueName[0]) {
            this.StandardValueName = StandardValueName[0].Text
          }
          if (!this.StandardValue) { this.StandardValueName = "" }
      },
      changeSwStandard: async function () {
          if (this.isSwStandard == false) {
            this.StandardValue = ""
            this.StandardValueName = ""
          }
      },
      changeSystemOilUnit: async function () {
          if(this.SystemOilUnit) {
            const SystemOilUnitNames = this.liquidUnits.filter(item => item.Value == this.SystemOilUnit)
            this.SystemOilUnitText = SystemOilUnitNames[0].Text
          }else {
            this.SystemOilUnitText = ""
          }
      },
      changeOperatingTimeUnit: async function () {
        if(this.OperatingTimeUnit) {
          const OperatingTimeUnitNames = this.useUnits.filter(item => item.Value == this.OperatingTimeUnit)
          this.OperatingTimeUnitText = OperatingTimeUnitNames[0].Text
        }else {
            this.OperatingTimeUnit = null
            this.OperatingTimeUnitText = ""
        }
      },
      changeTotalOperatingTimeUnit: async function () {
        if(this.TotalOperatingTimeUnit) {
          const TotalOperatingTimeUnitNames = this.useUnits.filter(item => item.Value == this.TotalOperatingTimeUnit)
          this.TotalOperatingTimeUnitText = TotalOperatingTimeUnitNames[0].Text
        }else {
          this.TotalOperatingTimeUnit = ""
          this.TotalOperatingTimeUnitText = ""
        }
      },

      changeSinceOverhaulTimeUnit: async function () {
        if(this.SinceOverhaulTimeUnit) {
          const SinceOverhaulTimeUnitNames = this.useUnits.filter(item => item.Value == this.SinceOverhaulTimeUnit)
          this.SinceOverhaulTimeUnitText = SinceOverhaulTimeUnitNames[0].Text
        }else {
          this.SinceOverhaulTimeUnit = ""
          this.SinceOverhaulTimeUnitText = ""
        }
      },
      changeOilChangeUnit: async function () {
        if(this.OilChangeUnit) {
          const OilChangeUnitNames = this.liquidUnits.filter(item => item.Value == this.OilChangeUnit)
          this.OilChangeUnitText = OilChangeUnitNames[0].Text
        }else {
          this.OilChangeUnit = null
          this.OilChangeUnitText = ""
        }
      },
      changeOilUsageTimeUnit: async function () {
        if(this.OilUsageTimeUnit) {
          const OilUsageTimeUnitNames = this.useUnits.filter(item => item.Value == this.OilUsageTimeUnit)
          this.OilUsageTimeUnitText = OilUsageTimeUnitNames[0].Text
        }else {
          this.OilUsageTimeUnit = null
          this.OilUsageTimeUnitText = ""
        }
      },
      changeFilterUsageTimeUnit: async function () {
        if(this.FilterUsageTimeUnit) {
          const FilterUsageTimeUnitNames = this.useUnits.filter(item => item.Value == this.FilterUsageTimeUnit)
          this.FilterUsageTimeUnitText = FilterUsageTimeUnitNames[0].Text
        }else {
          this.FilterUsageTimeUnit = null
          this.FilterUsageTimeUnitText = ""
        }
      },
      changeNewTotalOperatingTimeUnit: async function () {
        if(this.newTotalOperatingTimeUnit) {
          const TotalOperatingTimeUnitNames = this.useUnits.filter(item => item.Value == this.newTotalOperatingTimeUnit)
          this.newTotalOperatingTimeUnitText = TotalOperatingTimeUnitNames[0].Text
        }else {
          this.newTotalOperatingTimeUnit = ""
          this.newTotalOperatingTimeUnitText = ""
        }
      },

      changeNewOilChangeUnit: async function () {
        if(this.newOilChangeUnit) {
          const OilChangeUnitNames = this.liquidUnits.filter(item => item.Value == this.newOilChangeUnit)
          this.newOilChangeUnitText = OilChangeUnitNames[0].Text
        }else {
          this.newOilChangeUnit = null
          this.newOilChangeUnitText = ""
        }
      },      
      changeNewOilUsageTimeUnit: async function () {
        if(this.newOilUsageTimeUnit) {
          const OilUsageTimeUnitNames = this.useUnits.filter(item => item.Value == this.newOilUsageTimeUnit)
          this.newOilUsageTimeUnitText = OilUsageTimeUnitNames[0].Text
        }else {
          this.newOilUsageTimeUnit = null
          this.newOilUsageTimeUnitText = ""
        }
      },
      changeNewFilterUsageTimeUnit: async function () {
        if(this.newFilterUsageTimeUnit) {
          const FilterUsageTimeUnitNames = this.useUnits.filter(item => item.Value == this.newFilterUsageTimeUnit)
          this.newFilterUsageTimeUnitText = FilterUsageTimeUnitNames[0].Text
        }else {
          this.newFilterUsageTimeUnit = null
          this.newFilterUsageTimeUnitText = ""
        }
      },
      changeNewSinceOverhaulTimeUnit: async function () {
        if(this.newSinceOverhaulTimeUnit) {
          const SinceOverhaulTimeUnitNames = this.useUnits.filter(item => item.Value == this.newSinceOverhaulTimeUnit)
          this.newSinceOverhaulTimeUnitText = SinceOverhaulTimeUnitNames[0].Text
        }else {
          this.newSinceOverhaulTimeUnit = ""
          this.newSinceOverhaulTimeUnitText = ""
        }
      },

      changeLatestOperatingTimeUnit: async function () {
        if(this.LatestOperatingTimeUnit) {
          const LatestOperatingTimeUnitNames = this.useUnits.filter(item => item.Value == this.LatestOperatingTimeUnit)
          this.LatestOperatingTimeUnitText = LatestOperatingTimeUnitNames[0].Text
        }else {
          this.LatestOperatingTimeUnit = null
          this.LatestOperatingTimeUnitText = ""
        }
      },
      changeOilTypeCategory: async function() {
//        const oilTypeCategorys = this.$store.state.oilTypeCategoryList.filter(item => item.Value  == this.OilTypeCategory)
        const oilTypeCategorys = this.oilTypeCategoryList.filter(item => item.Value  == this.OilTypeCategory)
        this.OilTypeCategoryText = oilTypeCategorys[0].Text

        // オイルの種類のリストを更新
//        const oilTypes = this.$store.state.oilTypeList.filter(item => item.OilTypeCategory  == this.OilTypeCategory)
//        this.OilTypeList = oilTypes[0].OilType
        this.OilTypeList = await this.getOilTypeList(this.OilTypeCategory + this.AnalizeTypeCategory)

        const analizeTypeGroup = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
//        if(analizeTypeGroup[0]) {
//          this.AnalizeType = String(Number(analizeTypeGroup[0].Code) + Number(this.OilTypeCategory))
        if(this.AnalizeTypeGroup) {
          this.AnalizeType = String(Number(analizeTypeGroup[0].Code) + Number(this.OilTypeCategory))
          this.changeAnalizeType()
        }
      },
      changeOilType: async function() {
        const oilType = this.OilTypeList.filter(item => item.Value  == this.OilType)
        this.OilTypeText = oilType[0].Text
        this.isHazardousMaterials = oilType[0].isHazardousMaterials
        this.isAccept = oilType[0].isAccept
        console.log("changeOilType:", this.OilTypeText)
        console.log("isHazardousMaterials:", this.isHazardousMaterials)
        console.log("isAccept:", this.isAccept)
        if(oilType[0].Properties == "true") {
          this.hasOilProperties = true
        }else {
          this.hasOilProperties = false
        }
        this.OilProperty = ""
        this.OilPropertyText = ""
      },
      changeOilProperty: async function() {
        const oilProperty = this.OilPropertyList.filter(item => item.Value  == this.OilProperty)
        this.OilPropertyText = oilProperty[0].Text
      },
      changeMachineCategory: async function() {
        this.machineTypeList = await this.getMachineTypeList(this.MachineCategory)
/*
        let machineTypeListKey = "machineTypes" + this.MachineCategory
        let machineTypeList = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: machineTypeListKey}))
        this.machineTypeList = machineTypeList.data.sortedCodesByType.items

        let oilGradeListKey = "oilGrade" + this.MachineCategory
        let oilGradeList = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: oilGradeListKey}))
        this.oilGradeList = oilGradeList.data.sortedCodesByType.items
*/
      },
      changeMaker: async function() {
        this.MakerText = this.MakerID
      },
/*
      calcOperatingTime: async function () {
          this.OperatingTime = this.TotalOperatingTime - this.LatestOperatingTime
          this.OperatingTimeUnit = this.TotalOperatingTimeUnit
          this.OperatingTimeUnitText = this.TotalOperatingTimeUnitText
      },
*/
      getAnalizeItemName(analizeItem) {
        let item = this.analizeItemList.filter(item => item.Value  == analizeItem)
        return item[0].Text

      },
      openWindow (url) {
        window.open(url, '_blank')
      },
      handler (event) {
        event.returnValue = "Data you've inputted won't be synced"
        console.log('ページ離脱')
      },
      getMachine: async function () {
        let machine = await API.graphql(graphqlOperation(getMachine, {id: this.machineid}))
        console.log("getMachine:", machine)
        this.Name = machine.data.getMachine.Name
        this.CustomerMachineID = machine.data.getMachine.CustomerMachineID
        this.Equipment =  machine.data.getMachine.Equipment
        this.CustomerName =  machine.data.getMachine.CustomerName
        this.MakerID = machine.data.getMachine.MakerID
        this.MakerText = machine.data.getMachine.MakerID
        this.ModelNumber = machine.data.getMachine.ModelNumber
        this.PurchasedDate = machine.data.getMachine.PurchasedDate
        this.SystemOil = machine.data.getMachine.SystemOil
        this.SystemOilUnit = machine.data.getMachine.SystemOilUnit
        this.SystemOilUnitText = machine.data.getMachine.SystemOilUnitText
        this.MachineMemo = machine.data.getMachine.MachineMemo
        this.TotalOperatingTime = machine.data.getMachine.TotalOperatingTime
        this.TotalOperatingTimeUnit = machine.data.getMachine.TotalOperatingTimeUnit
        this.TotalOperatingTimeUnitText = machine.data.getMachine.TotalOperatingTimeUnitText
        this.OperatingTime = machine.data.getMachine.OperatingTime
        this.OperatingTimeUnit = machine.data.getMachine.OperatingTimeUnit
        this.OperatingTimeUnitText = machine.data.getMachine.OperatingTimeUnitText
        this.OilmakerID = machine.data.getMachine.OilmakerID
        if(machine.data.getMachine.OilmakerText == undefined) {
          this.OilmakerText = machine.data.getMachine.OilmakerID
        }else {
          this.OilmakerText = machine.data.getMachine.OilmakerText
        }
        this.OilModelNumber = machine.data.getMachine.OilModelNumber
        let _OilTypeCategory = machine.data.getMachine.OilTypeCategory
        let _OilType = machine.data.getMachine.OilType
        this.OilTypeCategoryText = machine.data.getMachine.OilTypeCategoryText
        this.OilTypeText = machine.data.getMachine.OilTypeText
        let _OilProperty = machine.data.getMachine.OilProperty
        let _OilPropertyText = machine.data.getMachine.OilPropertyText
        this.isHazardousMaterials = machine.data.getMachine.isHazardousMaterials
        this.HazardousMaterialsDetail = machine.data.getMachine.HazardousMaterialsDetail
        this.SamplingPlace = machine.data.getMachine.SamplingPlace
        this.SamplingBy = machine.data.getMachine.SamplingBy
        this.OilChangeDate = machine.data.getMachine.OilChangeDate
        this.OilChange = machine.data.getMachine.OilChange
        this.OilChangeUnit = machine.data.getMachine.OilChangeUnit
        this.OilChangeUnitText = machine.data.getMachine.OilChangeUnitText
        this.OilUsageTime = machine.data.getMachine.OilUsageTime
        this.OilUsageTimeUnit = machine.data.getMachine.OilUsageTimeUnit
        this.OilUsageTimeUnitText = machine.data.getMachine.OilUsageTimeUnitText

        if(machine.data.getMachine.FilterUsageTime != undefined) {
          this.UseFilter = machine.data.getMachine.UseFilter
          this.FilterUsageTime = machine.data.getMachine.FilterUsageTime
          this.FilterUsageTimeUnit = machine.data.getMachine.FilterUsageTimeUnit
          this.FilterUsageTimeUnitText = machine.data.getMachine.FilterUsageTimeUnitText
        }

        this.OverhaulDate = machine.data.getMachine.OverhaulDate
        this.SinceOverhaulTime = machine.data.getMachine.SinceOverhaulTime
        this.SinceOverhaulTimeUnit = machine.data.getMachine.SinceOverhaulTimeUnit
        this.SinceOverhaulTimeUnitText = machine.data.getMachine.SinceOverhaulTimeUnitText

        this.AnalizeTypeGroup = machine.data.getMachine.AnalizeTypeGroup
        this.AnalizeType = machine.data.getMachine.AnalizeType

        this.AnalizePurpose = machine.data.getMachine.AnalizePurpose
        this.StandardValue = machine.data.getMachine.StandardValue
        this.Surplus = machine.data.getMachine.Surplus
        this.Filter = machine.data.getMachine.Filter
        this.OfficeID = machine.data.getMachine.OfficeID
        if(machine.data.getMachine.LatestOrderAt)
          this.LatestOrderAt = machine.data.getMachine.LatestOrderAt.substring(0,10)
        this.LatestOrderNumber = machine.data.getMachine.LatestOrderNumber
        this.LatestOperatingTime = machine.data.getMachine.LatestOperatingTime
        this.LatestOperatingTimeUnit = machine.data.getMachine.LatestOperatingTimeUnit
        this.LatestOperatingTimeUnitText = machine.data.getMachine.LatestOperatingTimeUnitText

        this.isAccept = machine.data.getMachine.isAccept

        // この機器が機体と関連づいている場合は機体情報を取得
        if((machine.data.getMachine.MountedMachineID != undefined) && (machine.data.getMachine.MountedMachineID != "")) {
          this.Name = "" //機体と紐づいたらマイ機器名はリセット
          let mountedMachine = await API.graphql(graphqlOperation(getMachine, {id: machine.data.getMachine.MountedMachineID}))
          this.mountedMachine = mountedMachine.data.getMachine
          this.MountPosition = machine.data.getMachine.MountPosition
        }

        await this.changeAnalizeTypeGroup()
        this.analizeTypeList = this.analizeTypeList.filter(item => item.AnalizeTypeGroup  == this.AnalizeTypeGroup)
        this.analizeSetList = await this.getAnalizeSetList(this.AnalizeType)
        this.analizeItemList = await this.getAnalizeItemList(this.AnalizeType)
        this.activeAnalizeItemList = this.analizeItemList
        this.analizeItemSubList = await this.getAnalizeItemSubList(this.AnalizeType)

        this.AnalizeSet = machine.data.getMachine.AnalizeSet
        this.AnalizeItems = JSON.parse(machine.data.getMachine.AnalizeItems)

//          this.AnalizeItemSub = new Map
        this.AnalizeItemSub = {}
        if(machine.data.getMachine.AnalizeItemSub != undefined) {
//          this.AnalizeItemSub = machine.data.getMachine.AnalizeItemSub
          let _AnalizeItemSub = JSON.parse(machine.data.getMachine.AnalizeItemSub)

          for (var parentItem of Object.keys(_AnalizeItemSub)) {
              this.AnalizeItemSub[parentItem] = _AnalizeItemSub[parentItem]
//              this.AnalizeItemSub.set(parentItem, _AnalizeItemSub[parentItem])
          }
        }

        console.log("this.AnalizeItemSub:", this.AnalizeItemSub)
        console.log("this.analizeItemSubList:", this.analizeItemSubList)
        this.analizeItemNames = await this.getAnalizeItemNames(this.AnalizeItems, this.AnalizeItemSub, this.analizeItemList, this.analizeItemSubList)
        console.log("analizeItemNames:", this.analizeItemNames)

/* 一旦削除！
        let standardvaluelist = this.$store.state.standardValueList.filter(item => item.AnalizeType  == this.AnalizeType)
        this.standardValueList = standardvaluelist[0].standardValues
*/

        this.samplingurl = process.env.VUE_APP_MACHINE_QRCODE + machine.data.getMachine.id

        const AnalizeTypeGroupName = this.analizeTypeGroupList.filter(item => item.Value  == this.AnalizeTypeGroup)
        this.AnalizeTypeGroupName = AnalizeTypeGroupName[0].Text

        const AnalizeTypeName = this.analizeTypeList.filter(item => item.Value  == this.AnalizeType)
        this.AnalizeTypeName = AnalizeTypeName[0].Text

        if(this.AnalizeSet) {
          console.log("analize set is", this.AnalizeSet)
          const AnalizeSetName = this.analizeSetList.filter(item => item.Value  == this.AnalizeSet)
          if(AnalizeSetName[0]) {
            this.AnalizeSetName = AnalizeSetName[0].Text
            console.log("analize set name", this.AnalizeSetName)
            this.analizeSetItems = []
            this.activeAnalizeItemList = await this.excludeAnalizeItems(AnalizeSetName[0].AnalizeItems, this.analizeItemList)

            this.analizeSetItems = await this.getAnalizeSetItems(AnalizeSetName[0])
            this.isSelectAnalizeSet = true
          }else {
            console.log("analize set name not fount", this.AnalizeSet)
            this.AnalizeSetName = ''
            this.AnalizeSet = ""
            this.AnalizeSetName = ""
            this.analizeSetItems = []
          }
        } else {
          console.log("analize set not select", this.AnalizeSet)
          this.AnalizeSetName = ''
          this.AnalizeSet = ""
          this.AnalizeSetName = ""
          this.analizeSetItems = []
        }

        const StandardValueName = this.standardValueList.filter(item => item.Value  == this.StandardValue)
        if (StandardValueName.length > 0 ) { 
          this.StandardValueName = StandardValueName[0].Text
          this.isSwStandard = true 
        } else {
          this.StandardValueName = 'なし'
        }

        this.OilTypeCategory = _OilTypeCategory
//        const oilTypes = this.$store.state.oilTypeList.filter(item => item.OilTypeCategory  == this.OilTypeCategory)
//        if(oilTypes[0]) {
//          this.OilTypeList = oilTypes[0].OilType
//          this.OilType = _OilType
//        }
        this.OilTypeList = await this.getOilTypeList(this.OilTypeCategory + this.AnalizeTypeCategory)
        this.OilType = _OilType

        await this.changeOilType()
        this.OilProperty = _OilProperty
        this.OilPropertyText = _OilPropertyText

      },
      toUpdateMachine: async function() {
        this.isConfirmed = false
        this.successCreateMachine = false
        this.processing = false
        this.isCreate = false
        this.isCreateMounted = false
        this.isDetailInput = false
        await this.initialize()
        this.moveToTop()
      },
      initialize: async function() {
        let machineCategoryList = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "machineCategory" + this.AnalizeTypeGroup + "装備装置"}))
        this.MachineCategoryList = machineCategoryList.data.sortedCodesByType.items

//        let _analizeTypeGroupList = await API.graphql(graphqlOperation(analizeTypeGroupByCategory, {AnalizeTypeCategory: this.AnalizeTypeCategory}))
//        this.analizeTypeGroupList = _analizeTypeGroupList.data.analizeTypeGroupByCategory.items
        this.analizeTypeGroupList = await this.getAnalizeTypeGroupList(this.AnalizeTypeCategory)

//        let _oilCategory = await API.graphql(graphqlOperation(sortedCodesByType, {CodeType: "oilCategory" + this.AnalizeTypeCategory}))
//        this.oilTypeCategoryList = _oilCategory.data.sortedCodesByType.items
        this.oilTypeCategoryList = await this.getOilTypeCategoryList(this.AnalizeTypeCategory)

        this.machineCategoryList = await this.getMachineCategoryList(this.AnalizeTypeCategory, this.Type)

        if(this.machineid) {
          await this.getMachine()
        }

        // 航空機の場合、使用時間系の単位はHr固定
        if(this.AnalizeTypeCategory == "航空機") {
          this.TotalOperatingTimeUnit = "10000002"
          this.TotalOperatingTimeUnitText = ""
          this.SinceOverhaulTimeUnit = "10000002"
          this.SinceOverhaulTimeUnitText = ""
          this.FilterUsageTimeUnit = "10000002"
          this.FilterUsageTimeUnitText = ""
          this.OilUsageTimeUnit = "10000002"
          this.OilUsageTimeUnitText = ""
        }

      },
      openMachineLog(id) {
        this.$refs.machineLog.open(id);
      }
    },
    mounted: async function () {
      console.log('params machine id: ', this.$route.query.id)
      console.log('params machine category: ', this.$route.query.category)
      console.log('params machine type: ', this.$route.query.type)
      console.log('params mount machine: ', this.$route.query.mountmachine)

//      this.backPage = this.$route.query.page

      if (this.$route.query.id == undefined){
        console.log('isCreate: ', this.isCreate)

        this.isCreate = true
        this.isDetailInput = true
        this.AnalizeTypeCategory = this.$route.query.category
        this.Type = this.$route.query.type
        this.isCreateMounted = false

        if(this.$route.query.mountmachine != undefined) {
          this.isCreateMounted = true

          let mountedMachine = await API.graphql(graphqlOperation(getMachine, {id: this.$route.query.mountmachine}))
          this.mountedMachine = mountedMachine.data.getMachine
        }

        this.showDescription1 = true
        this.showDescription2 = true
        this.showDescription3 = true

        this.overlayStepper1 = false
      }else {
        this.isCreate = false
        this.isDetailInput = false
        this.machineid = this.$route.query.id

        let machine = await API.graphql(graphqlOperation(getMachine, {id: this.machineid}))

        // マイ機器情報のアクセスチェック
        // 存在しないマイ機器、他事業所のマイ機器を開いた場合はアクセス不正でエラーにする
        if(!machine.data.getMachine) {
          this.isErrorParam = true
          this.ErrorInfo = "notExist"
          this.overlayStepper1 = false
          console.log('isErrorParam: ', this.isErrorParam)
          return
        }
        if(machine.data.getMachine.OfficeID != this.$store.state.operatingOffice.OfficeID) {
          this.isErrorParam = true
          this.ErrorInfo = "illegalAccess"
          this.overlayStepper1 = false
          console.log('isErrorParam: ', this.isErrorParam)
          return
        }

        this.AnalizeTypeCategory = this.getMachineAnalizeTypeCategory(machine.data.getMachine)
        this.Type = this.getMachineType(machine.data.getMachine)
      }
      console.log("AnalizeTypeCategory: ", this.AnalizeTypeCategory)
      console.log("Type: ", this.Type)

      if(this.AnalizeTypeCategory == "航空機") {
        this.machineTypeText = "装備品"
      }else {
        this.machineTypeText = "マイ機器"
      }

      this.initialize()

      this.overlayStepper1 = false
    },
  created () {
    window.addEventListener("beforeunload", this.handler)
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.handler)
  }      
  }
</script>

<style lang="scss" scoped>
.wrap-text {
  overflow-wrap: break-all;
  word-break: break-all;
//  white-space: normal;
  white-space: pre-line;
}

</style>